/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import { getStorage, listAll } from "firebase/storage";
import { Link, useNavigate } from "react-router-dom";
import { useUserAuth } from "../../context/UserAuthContext";
import { db, storage } from "../../firebase-config";
import { ref, onValue, get, set, runTransaction, query, orderByChild, limitToLast, endBefore, onChildAdded, onChildChanged, onChildRemoved, off } from "firebase/database";
import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import "./DocPanel1.css"; // Ensure this imports the CSS with the copied styles
import "../../AdminPages/AssignDoctor/AssignDoctor.css";
import Modal from "react-modal";
import PatientItem from "./PatientItem";
import ChatNot from "../../components/Chat/ChatNot";
import "../../components/Chat/ChatNot.css";
import CryptoJS from "crypto-js"; // For encryption and decryption
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import DownloadIcon from "@mui/icons-material/Download";
import ShareIcon from "@mui/icons-material/Share";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import ThreeDRotationIcon from "@mui/icons-material/ThreeDRotation";
import HistoryIcon from "@mui/icons-material/History";
import AddIcon from "@mui/icons-material/Add";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import FileDownloadOffOutlinedIcon from "@mui/icons-material/FileDownloadOffOutlined";
import DoDisturbOutlinedIcon from "@mui/icons-material/DoDisturbOutlined";
import Tooltip from "@mui/material/Tooltip";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import IconButton from "@mui/material/IconButton";
import Pagination from "@mui/material/Pagination";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrescription } from "@fortawesome/free-solid-svg-icons";
import { AIModelHandler } from "../../API/AIModelHandler"; // Import the new AI architecture handler
import {
  logDoctor3DView,
  logDoctorPatientRecordView,
  logDoctorViewReport,
  logDoctorDownloadReport,
  logDoctor3DViewAction,
} from "./DoctorAuditLogs"; //deepa auditlogs

const isValidString = (value) =>
  typeof value === "string" && value.trim() !== "";

const decrypt = (data) => {
  try {
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    if (!secretKey) {
      console.error("Secret key is not defined");
      return data;
    }
    if (typeof data === "string" && data.startsWith("U2FsdGVkX1")) {
      const bytes = CryptoJS.AES.decrypt(data, secretKey);
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
      if (!decryptedText) throw new Error("Decryption failed");
      return decryptedText;
    }
    return data; // Return data as-is if not encrypted
  } catch (error) {
    console.error("Decryption error:", error);
    return data;
  }
};

const encryptData = (data) => {
  try {
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    if (!secretKey) {
      console.error("Secret key is not defined");
      return data;
    }
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  } catch (error) {
    console.error("Encryption error:", error);
    return data;
  }
};

Modal.setAppElement("#root");
const visiblePageNumbers = 3;

const DoctorPanel = () => {
  const { logOut } = useUserAuth();
  const navigate = useNavigate();

  // Helper function to get doctor data (handles both encrypted and plain text)
  const getDoctorData = (doctorData, fieldName) => {
    if (!doctorData) return null;

    // First try direct field access (for legacy plain text data)
    if (doctorData[fieldName] !== undefined && doctorData[fieldName] !== null) {
      return decryptDataIfNeeded(doctorData[fieldName]);
    }

    // Then try to find encrypted key version
    for (const key in doctorData) {
      try {
        // Simple check if key might be encrypted (contains non-alphanumeric chars)
        if (key.includes("_") || key.length > 20) {
          const decryptedKey = decryptDataIfNeeded(key);
          if (decryptedKey === fieldName) {
            return decryptDataIfNeeded(doctorData[key]);
          }
        }
      } catch (error) {
        continue; // Continue to next key if decryption fails
      }
    }

    return null;
  };
  const handleLogout = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      console.log(error.message);
    }
  };

  // State to manage the posts (patient data)
  const [posts, setPosts] = useState([]);

  /* BATCH LOADING SYSTEM - Loads patients in batches of 100 */
  const [batchSize] = useState(100);
  const [loadedBatches, setLoadedBatches] = useState(new Set());
  const [totalPatientCount, setTotalPatientCount] = useState(0);
  const [isLoadingBatch, setIsLoadingBatch] = useState(false);
  const [allPatientKeys, setAllPatientKeys] = useState([]);
  const [hasMorePatients, setHasMorePatients] = useState(true);
  const [oldestTimestamp, setOldestTimestamp] = useState(null);
  const [isSearchingFirebase, setIsSearchingFirebase] = useState(false);
  const [isInitialBatchLoaded, setIsInitialBatchLoaded] = useState(false);

  // State to track current patients with AI processing
  const [currentPatientsAi, setCurrentPatientsAi] = useState([]);

  // State to store doctors from the database
  const [doctors, setDoctors] = useState({});

  // State to store whether the license is valid
  const [hasValidLicense, setHasValidLicense] = useState(true);

  // State to track whether the clinical history modal is visible
  const [clinicalHistoryModalVisible, setClinicalHistoryModalVisible] =
    useState(false);

  // State to store the clinical history text
  const [clinicalHistoryText, setClinicalHistoryText] = useState("");

  // State to track the selected patient's ID for clinical history
  const [selectedPatientId, setSelectedPatientId] = useState("");

  // State to store an attached file if there is one
  const [attachedFile, setAttachedFile] = useState(null);

  // State to track if we're editing existing history or adding new
  const [isEditingExistingHistory, setIsEditingExistingHistory] =
    useState(false);

  // State to track whether the user is in edit mode (matching Technician Panel)
  const [isEditing, setIsEditing] = useState(false);

  // State to manage the share modal visibility
  const [modalVisible, setModalVisible] = useState(false);

  // State to store the selected link to be shared
  const [selectedLink, setSelectedLink] = useState("");

  // State to manage the search terms for filtering patients
  const [searchTerms, setSearchTerms] = useState({
    patientId: "",
    fullName: "",
    modality: "",
  });

  // Helper function to parse a date string into a Date object
  const parseDate = (dateString) => {
    if (!dateString || dateString === "N/A" || dateString === "Not Set") {
      return new Date(0); // Default to epoch time if invalid
    }
    
    // Try parsing as ISO format first (YYYY-MM-DDTHH:mm:ss.sssZ)
    const isoDate = new Date(dateString);
    if (!isNaN(isoDate.getTime())) {
      return isoDate; // Valid ISO format
    }
    
    // Fallback: Try parsing old format (dd/mm/yyyy, hh:mm:ss)
    if (dateString.includes(",")) {
      const [datePart, timePart] = dateString.split(", "); // Separate date and time
      const [day, month, year] = datePart.split("/").map(Number); // Extract day, month, year
      const [hours = 0, minutes = 0, seconds = 0] = timePart
        ? timePart.split(":").map(Number)
        : [0, 0, 0]; // Extract time or default to zero
      return new Date(year, month - 1, day, hours, minutes, seconds); // Create a Date object
    }
    
    return new Date(0); // Invalid format
  };

  // Format timestamp for display (converts ISO to dd/mm/yyyy, hh:mm:ss)
  const formatTimestampForDisplay = (timestamp) => {
    if (!timestamp) return "NA";
    
    // If already in old format (contains comma), return as-is
    if (timestamp.includes(", ")) {
      return timestamp;
    }
    
    // Parse ISO format and convert to readable format
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return timestamp; // Return original if invalid
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
  };

  // Helper function to determine the sorting date
  // Sort by Received time (Timestamp) - latest first
  const getSortingDate = (patient) => {
    const timestampDate = parseDate(patient.Timestamp); // Parse Timestamp (Received time)
    return timestampDate; // Sort by Received time only
  };

  const filteredPatients = posts.filter((patient) => {
    const fullName = patient?.FullName?.toLowerCase() || "";
    const patientId = patient?.ID?.toLowerCase() || "";

    // Standardize invalid modalities
    const INVALID_MODALITIES = ["n/a", "not selected", "na"];

    // Extract the latest modality
    let latestModality = "n/a"; // Default value
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads)
        .filter((key) => key.startsWith("Scan"))
        .sort((a, b) => {
          const numA = parseInt(a.replace("Scan ", ""), 10);
          const numB = parseInt(b.replace("Scan ", ""), 10);
          return numB - numA; // Sort descending
        });

      for (const key of scanKeys) {
        const scan = patient.uploads[key];
        if (
          scan.Modality &&
          typeof scan.Modality === "string" &&
          scan.Modality.trim() !== "" &&
          !INVALID_MODALITIES.includes(scan.Modality.trim().toLowerCase())
        ) {
          latestModality = scan.Modality.trim().toLowerCase();
          break;
        }
      }
    }

    // Fallback to patient.Modality if uploads are not available
    if (!latestModality || INVALID_MODALITIES.includes(latestModality)) {
      latestModality =
        typeof patient.Modality === "string" &&
        patient.Modality.trim() !== "" &&
        !INVALID_MODALITIES.includes(patient.Modality.trim().toLowerCase())
          ? patient.Modality.trim().toLowerCase()
          : "n/a"; // Default to "n/a"
    }

    // Apply filters based on search terms
    return (
      fullName.includes(searchTerms.fullName.toLowerCase()) &&
      patientId.includes(searchTerms.patientId.toLowerCase()) &&
      (searchTerms.modality === "" ||
        (searchTerms.modality.toLowerCase() === "na" &&
          INVALID_MODALITIES.includes(latestModality)) ||
        latestModality === searchTerms.modality.toLowerCase())
    );
  }).sort((a, b) => {
    // Priority patients (non-finalized) first
    const aIsPriorityActive = a.isPriority && a.Report_Status !== "Final";
    const bIsPriorityActive = b.isPriority && b.Report_Status !== "Final";
    
    if (aIsPriorityActive && !bIsPriorityActive) return -1;
    if (!aIsPriorityActive && bIsPriorityActive) return 1;
    
    // Then sort by date
    const dateA = getSortingDate(a);
    const dateB = getSortingDate(b);
    return dateB - dateA;
  });

  const [currentPage, setCurrentPage] = useState(1);

  // Viniith Fix this 05-08-2025 - Reset current page when search terms change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerms]); // Viniith Fix this 05-08-2025

  // Search Firebase for specific patient by Name or ID
  const searchPatientInFirebase = async (searchName, searchId) => {
    if (!adminName1 || !docName || (!searchName && !searchId) || isSearchingFirebase) return;
    
    setIsSearchingFirebase(true);
    
    try {
      const patientsRef = ref(db, `superadmin/admins/${adminName1}/patients`);
      const snapshot = await get(patientsRef);
      const allPatients = snapshot.val();
      
      if (!allPatients) {
        setIsSearchingFirebase(false);
        return;
      }
      
      const foundPatients = [];
      Object.keys(allPatients).forEach((patientId) => {
        const patient = allPatients[patientId];
        const decryptedName = decryptDataIfNeeded(patient.FullName);
        const decryptedId = decryptDataIfNeeded(patient.ID);
        
        const matchesName = searchName ? decryptedName.toLowerCase().includes(searchName.toLowerCase().trim()) : true;
        const matchesId = searchId ? decryptedId.toLowerCase().includes(searchId.toLowerCase().trim()) : true;
        
        if (matchesName && matchesId) {
          const processed = processPatientForDoctor(patientId, patient);
          if (processed) {
            foundPatients.push(processed);
          }
        }
      });
      
      // Add found patients to posts if not already present
      if (foundPatients.length > 0) {
        setPosts(prev => {
          const combined = [...prev, ...foundPatients];
          // Remove duplicates
          const uniqueMap = new Map(combined.map(p => [p.id, p]));
          const uniquePatients = Array.from(uniqueMap.values());
          
          // Re-sort to ensure priority patients (non-finalized) are at top
          uniquePatients.sort((a, b) => {
            // Priority patients (non-finalized) first
            const aIsPriorityActive = a.isPriority && a.Report_Status !== "Final";
            const bIsPriorityActive = b.isPriority && b.Report_Status !== "Final";
            
            if (aIsPriorityActive && !bIsPriorityActive) return -1;
            if (!aIsPriorityActive && bIsPriorityActive) return 1;
            
            // Then sort by date
            const dateA = getSortingDate(a);
            const dateB = getSortingDate(b);
            return dateB - dateA;
          });
          
          return uniquePatients;
        });
      } else {
        toast.info("No matching patients found", {
          position: "top-center",
          autoClose: 2000
        });
      }
    } catch (error) {
      console.error("Error searching patient in Firebase:", error);
      toast.error("Error searching database", {
        position: "top-center"
      });
    } finally {
      setIsSearchingFirebase(false);
    }
  };

  // Search Firebase if patient not found in loaded data
  useEffect(() => {
    const hasSearchTerm = searchTerms.fullName.trim() || searchTerms.patientId.trim();
    
    if (hasSearchTerm && filteredPatients.length === 0 && posts.length > 0 && !isSearchingFirebase) {
      // No results found in current data, search Firebase after a small delay
      const timeoutId = setTimeout(() => {
        searchPatientInFirebase(searchTerms.fullName, searchTerms.patientId);
      }, 500); // 500ms delay to avoid searching on every keystroke
      
      return () => clearTimeout(timeoutId);
    }
  }, [searchTerms.fullName, searchTerms.patientId]);

  // State to track progress of AI tasks per patient
  const [progressPercentages, setProgressPercentages] = useState({});

  // State to manage status messages for AI tasks
  const [statusMessages, setStatusMessages] = useState({});

  // State to handle AI task polling intervals
  const intervalsRef = useRef({});

  // State to track the mobile view status
  const [isMobile, setIsMobile] = useState(false);

  // State to track whether the prescription modal is visible
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [directUpload, setDirectUpload] = useState(false);

  // State to track the selected patient for prescription
  const [selectedPatient, setSelectedPatient] = useState(null);

  // State to manage the number of patients per page for pagination
  const [patientsPerPage] = useState(20);

  // State to track the role of the doctor (e.g., Radiologist)
  const [role, setRole] = useState("");

  // State to track the doctor ID
  const [doctorId, setDoctorId] = useState("");

  // State to track the length of the longest patient name for column width
  const longestNameLengthRef = useRef(0);

  // State to manage whether there are no patients assigned
  const [noPatientsAssigned, setNoPatientsAssigned] = useState(false);

  // State for handling popup for expired or invalid license
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupDescription, setPopupDescription] = useState("");
  const [loadingAI, setLoadingAI] = useState({});

  // deepa fix ui - State to control flash message visibility
  const [showFlashMessage, setShowFlashMessage] = useState(true);

  // State for managing the selected doctor's name for assignment
  const adminName1 = localStorage.getItem("adminName");
  const docName = localStorage.getItem("docName");

  // State to force refresh of patient data after prescription upload
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  //state for choosing ai model
  const [aiModalVisible, setAiModalVisible] = useState(false);
  const [aiModalPatientId, setAiModalPatientId] = useState(null);
  const [aiModelsEnabled, setAiModelsEnabled] = useState({});
  const [showContouringSubMenu, setShowContouringSubMenu] = useState(false);

  // wallet related states:
  const [costingType, setCostingType] = useState(""); // e.g. "Prepaid", "Postpaid", etc.
  const [walletBalance, setWalletBalance] = useState(0);
  const [boneFractureCost, setBoneFractureCost] = useState(0);
  const [contouringModelCost, setContouringModelCost] = useState(0);
  const [tbModelCost, setTbModelCost] = useState(0);
  const [cxrTbCost, setCxrTbCost] = useState(0);
  const [cxrTb2Cost, setCxrTb2Cost] = useState(0);
  const [cxrMulticlassCost, setCxrMulticlassCost] = useState(0);
  const [xrayFractureCost, setXrayFractureCost] = useState(0);
  const [threeDAbdomenCost, setThreeDAbdomenCost] = useState(0);
  const [tumorAbdomenCost, setTumorAbdomenCost] = useState(0);
  const [contourAbdomenCost, setContourAbdomenCost] = useState(0);
  // 1. Add state for Liver-Segmentation cost
  const [liverSegmentationCost, setLiverSegmentationCost] = useState(0);
  // 2. Add state for Contour-HaN cost
  const [contourHaNModelCost, setContourHaNModelCost] = useState(0);

  // We'll keep an array "aiTasks" describing each active or completed AI request
  // => an array of { patientId, model, subModel, status }
  const [aiTasks, setAiTasks] = useState([]);

  // For the AI Processing Status modal
  const [aiProcessingModalOpen, setAiProcessingModalOpen] = useState(false);
  const [aiProcessingModalMinimized, setAiProcessingModalMinimized] =
    useState(false);

  // useEffect for fetching costing type ,wallet balance and Bone_Fracture_Model cost
  useEffect(() => {
    if (adminName1) {
      // Wallet balance
      const walletBalanceRef = ref(
        db,
        `superadmin/admins/${adminName1}/Wallet/Wallet_Balance`
      );
      const unsubscribeWallet = onValue(walletBalanceRef, (snapshot) => {
        if (snapshot.exists()) {
          setWalletBalance(snapshot.val());
        }
      });

      // bone fracture
      const boneFractureCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/XRay-Fracture`
      );
      get(boneFractureCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setBoneFractureCost(snapshot.val());
        } else {
          setBoneFractureCost(0);
        }
      });

      // contouring
      const contouringCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Contour-Abdomen`
      );
      get(contouringCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setContouringModelCost(snapshot.val());
        } else {
          setContouringModelCost(0);
        }
      });

      // costingType
      const costingTypeRef = ref(
        db,
        `superadmin/admins/${adminName1}/CostingType`
      );
      get(costingTypeRef).then((snapshot) => {
        if (snapshot.exists()) {
          setCostingType(snapshot.val());
        } else {
          setCostingType("");
        }
      });

      // tbModelCost
      const tbModelCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/CXR-TB`
      );
      get(tbModelCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setTbModelCost(snapshot.val());
        } else {
          setTbModelCost(0);
        }
      });

      // CXR-TB Cost
      const cxrTbCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/CXR-TB`
      );
      get(cxrTbCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setCxrTbCost(snapshot.val());
        } else {
          setCxrTbCost(0);
        }
      });

      // CXR-TB2 Cost
      const cxrTb2CostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/CXR-TB2`
      );
      get(cxrTb2CostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setCxrTb2Cost(snapshot.val());
        } else {
          setCxrTb2Cost(0);
        }
      });

      // CXR-Multiclass Cost
      const cxrMulticlassCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/CXR-Multiclass`
      );
      get(cxrMulticlassCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setCxrMulticlassCost(snapshot.val());
        } else {
          setCxrMulticlassCost(0);
        }
      });

      // XRay-Fracture Cost
      const xrayFractureCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/XRay-Fracture`
      );
      get(xrayFractureCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setXrayFractureCost(snapshot.val());
        } else {
          setXrayFractureCost(0);
        }
      });

      // 3D-Abdomen Cost
      const threeDAbdomenCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/3D-Abdomen`
      );
      get(threeDAbdomenCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setThreeDAbdomenCost(snapshot.val());
        } else {
          setThreeDAbdomenCost(0);
        }
      });

      // Tumor-Abdomen Cost
      const tumorAbdomenCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Tumor-Abdomen`
      );
      get(tumorAbdomenCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setTumorAbdomenCost(snapshot.val());
        } else {
          setTumorAbdomenCost(0);
        }
      });

      // Contour-Abdomen Cost
      const contourAbdomenCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Contour-Abdomen`
      );
      get(contourAbdomenCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setContourAbdomenCost(snapshot.val());
        } else {
          setContourAbdomenCost(0);
        }
      });

      // Liver-Segmentation cost
      const liverSegmentationCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Liver-Segmentation`
      );
      get(liverSegmentationCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setLiverSegmentationCost(snapshot.val());
        } else {
          setLiverSegmentationCost(0);
        }
      });

      // Contour-HaN cost
      const contourHaNModelCostRef = ref(
        db,
        `superadmin/admins/${adminName1}/costing/Contour-HaN`
      );
      get(contourHaNModelCostRef).then((snapshot) => {
        if (snapshot.exists()) {
          setContourHaNModelCost(snapshot.val());
        } else {
          setContourHaNModelCost(0);
        }
      });

      return () => {
        unsubscribeWallet();
      };
    }
  }, [adminName1]);

  // Fetch the admin's AI models enabled flags from Firebase
  useEffect(() => {
    if (adminName1) {
      const aiEnabledRef = ref(
        db,
        `superadmin/admins/${adminName1}/AI_Model_Enabled`
      );
      onValue(aiEnabledRef, (snapshot) => {
        if (snapshot.exists()) {
          setAiModelsEnabled(snapshot.val());
        } else {
          // If not present, you could default to enabling all models
          setAiModelsEnabled({});
        }
      });
    }
  }, [adminName1]);

  // Calculate total pages, always add 1 extra if more patients can be loaded
  const totalPages = hasMorePatients 
    ? Math.ceil(filteredPatients.length / patientsPerPage) + 1 
    : Math.ceil(filteredPatients.length / patientsPerPage);
  const startIndex = (currentPage - 1) * patientsPerPage;
  const endIndex = startIndex + patientsPerPage;
  const currentPatients = filteredPatients.slice(startIndex, endIndex);

  const handleClinicalHistoryClick = (
    patientId,
    patient,
    isAddMode = false
  ) => {
    const clinicalTextFromDB = patient.Clinical_Textarea || "";
    const clinicalFileFromDB = patient.Clinical_Filepath || "";

    // Check if user has HOD or Radiologist role
    const userRole = localStorage.getItem("role");
    const isHOD = userRole === "hod";
    const isRadiologist = role === "Radiologist";
    const canAccessClinicalHistory = isHOD || isRadiologist;

    // Check if both clinical history text and file are unavailable
    if (
      !clinicalTextFromDB &&
      !clinicalFileFromDB &&
      !canAccessClinicalHistory
    ) {
      // Regular doctors can't access if no clinical history exists
      toast.info("No Clinical History Available", {
        position: "top-center",
      });
      return; // Exit the function early
    }

    // Decrypt the clinical file path if available
    let decryptedFilePath = clinicalFileFromDB
      ? decryptDataIfNeeded(clinicalFileFromDB)
      : null;

    // Decrypt clinical text if available
    const decryptedClinicalText = clinicalTextFromDB
      ? decryptDataIfNeeded(clinicalTextFromDB)
      : "";

    // Set the selected patient ID and clinical history data
    setSelectedPatientId(patientId);
    setClinicalHistoryText(decryptedClinicalText);
    setAttachedFile(decryptedFilePath ? { name: decryptedFilePath } : null);

    // Store whether this is an edit or add operation based on original DB data
    setIsEditingExistingHistory(!!(clinicalTextFromDB || clinicalFileFromDB));

    // Set editing mode based on whether it's add mode or if user is HOD and it's add mode
    if (isAddMode && isHOD) {
      setIsEditing(true); // Start in edit mode for add operations
    } else {
      setIsEditing(false); // Start in view mode for view operations
    }

    // Display the clinical history modal
    setClinicalHistoryModalVisible(true);
  };

  // Add near handleSaveClinicalHistory
  const handleCancelClinicalHistory = () => {
    // If this modal was opened as "Add" (no existing history) then close it fully
    if (isEditing && !isEditingExistingHistory) {
      setIsEditing(false);
      setAttachedFile(null);
      setClinicalHistoryModalVisible(false);
      // optionally clear clinicalHistoryText if you want to discard typed content:
      // setClinicalHistoryText("");
    } else {
      // Just exit edit mode and keep viewing
      setIsEditing(false);
      setAttachedFile(null);
    }
  };

  // Function to save clinical history changes (HOD only)
  const handleSaveClinicalHistory = async () => {
    if (!selectedPatientId) return; // Ensure patient ID is selected

    try {
      const updates = {};

      // Save clinical history text (matching Technician Panel)
      if (clinicalHistoryText !== undefined && clinicalHistoryText.trim()) {
        updates.Clinical_Textarea = clinicalHistoryText;
      }

      // Add timestamp
      const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
      };

      updates.Clinical_Timestamp = formatDate(new Date());

      // Handle file upload if a new file is attached
      if (attachedFile && attachedFile instanceof File) {
        const folderPath = `superadmin/admins/${adminName1}/patients/${selectedPatientId}`;

        try {
          // Delete existing file if it exists
          const currentPatient = posts.find((p) => p.id === selectedPatientId);
          if (currentPatient?.Clinical_Filepath) {
            try {
              const existingFileUrl = decryptDataIfNeeded(
                currentPatient.Clinical_Filepath
              );
              if (existingFileUrl && existingFileUrl.includes("firebase")) {
                // Extract file path from URL and delete it
                const existingFileRef = storageRef(storage, existingFileUrl);
                await deleteObject(existingFileRef);
                console.log("Deleted existing clinical history file");
              }
            } catch (deleteError) {
              console.warn("Could not delete existing file:", deleteError);
              // Continue with upload even if delete fails
            }
          }

          // Upload new file
          const fileReference = storageRef(
            storage,
            `${folderPath}/clinical_history/${attachedFile.name}`
          );

          const snapshot = await uploadBytes(fileReference, attachedFile);
          const fileUrl = await getDownloadURL(snapshot.ref);

          // Save file URL (matching Technician Panel - they encrypt it)
          updates.Clinical_Filepath = encryptData(fileUrl);
        } catch (error) {
          console.error("Error uploading file:", error);
          toast.error("Error uploading file", { position: "top-center" });
          return;
        }
      }

      // Save to database using runTransaction (matching Technician Panel)
      const patientRef = ref(
        db,
        `superadmin/admins/${adminName1}/patients/${selectedPatientId}`
      );

      await runTransaction(patientRef, (currentData) => ({
        ...currentData,
        ...updates,
      }));

      // Update local state
      setPosts((prevPosts) =>
        prevPosts.map((patient) =>
          patient.id === selectedPatientId
            ? { ...patient, ...updates }
            : patient
        )
      );

      toast.success("Clinical History saved successfully", {
        position: "top-center",
      });

      // Exit edit mode after saving
      setIsEditing(false);

      // Reset attached file
      setAttachedFile(null);

      // Close modal only if it was an add operation (no existing data)
      if (!isEditingExistingHistory) {
        setClinicalHistoryModalVisible(false);
      }
    } catch (error) {
      console.error("Error saving clinical history:", error);
      toast.error("Failed to save clinical history. Please try again.", {
        position: "top-center",
      });
    }
  };

  // Function to handle upload data for HOD
  const handleUploadData = (patientId) => {
    // Navigate to AddImage page with from parameter for proper back navigation
    const addImageUrl = `/Technician/AddImage${patientId}?page=${currentPage}&from=DoctorPanel`;
    window.open(addImageUrl, "_blank");
  };

  // Function to handle prescription upload completion and refresh patient data
  const handlePrescriptionUpload = (patientId) => {
    console.log("DocPanel - Prescription uploaded for patient:", patientId);
    // Trigger a refresh of patient data by incrementing the refresh trigger
    setRefreshTrigger((prev) => prev + 1);

    // Close the prescription modal after successful upload
    setShowPrescriptionModal(false);
    setDirectUpload(false);
  };

  const handleShareClick = (patientId) => {
    const baseUrl =
      process.env.NODE_ENV === "development"
        ? "http://localhost:3000"
        : "https://tryon.easiofy.com"; // <-- Updated AWS URL

    const generatedLink = `${baseUrl}/patient/${encryptOld(
      adminName1
    )}/${encryptOld(patientId)}`;

    setSelectedLink(generatedLink);
    setModalVisible(true);
  };
  // Decrypt function

  const handledescription = (patientId) => {
    // Find the patient from the list using their ID
    const patient = posts.find((patient) => patient.id === patientId);

    if (!patient) {
      toast.info("Patient not found", {
        position: "top-center",
      });
      return;
    }

    // Use the helper function to get prescription data (handles both legacy and Version 03)
    const { prescriptionURL, prescription } = getPrescriptionData(patient);

    if (!prescriptionURL) {
      toast.info("No Prescription available", {
        position: "top-center",
      });
      return;
    }

    try {
      // The prescriptionURL is already decrypted by getPrescriptionData helper function
      console.log("Opening prescription URL:", prescriptionURL);

      // Open the prescription URL in a new tab
      if (prescriptionURL && prescriptionURL.trim() !== "") {
        window.open(prescriptionURL, "_blank");
      } else {
        toast.info("Invalid prescription URL", {
          position: "top-center",
        });
      }
    } catch (error) {
      console.error("Error opening prescription URL:", error);
      toast.info("Failed to open prescription. Please try again later.", {
        position: "top-center",
      });
    }
  };

  // const decrypt = (encryptedData) => {
  //   try {
  //     const secretKey = process.env.REACT_APP_SECRET_KEY;
  //     const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  //     const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

  //     // If decryption produces empty result, return the original data
  //     return decryptedText || encryptedData;
  //   } catch (error) {
  //     console.error("Decryption error:", error);
  //     return encryptedData; // Return the original URL if decryption fails
  //   }
  // };

  // Encrypt function
  const encrypt = (data) => {
    const secretKey = process.env.REACT_APP_SECRET_KEY; // HIPAA-compliant secret key
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  };

  const encryptOld = (data) => {
    return window.btoa(data); // Base64 encoding
  };

  // const decryptData = (encryptedData) => {
  //   try {
  //     const secretKey = process.env.REACT_APP_SECRET_KEY; // HIPAA-compliant secret key
  //     const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  //     return bytes.toString(CryptoJS.enc.Utf8); // Convert decrypted bytes to string
  //   } catch (error) {
  //     console.warn("Error decrypting data:", error);
  //     return encryptedData; // Return original data if decryption fails
  //   }
  // };

  // const decryptDataIfNeeded = (data) => {
  //   try {
  //     const secretKey = process.env.REACT_APP_SECRET_KEY; // Ensure you have this key set in your environment
  //     if (typeof data === "string" && data.startsWith("U2FsdGVkX1")) {
  //       const bytes = CryptoJS.AES.decrypt(data, secretKey);
  //       const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  //       return decrypted || data; // Fallback to the original data if decryption fails
  //     }
  //     return data; // Return original data if not encrypted
  //   } catch (error) {
  //     console.error("Error decrypting data:", error);
  //     return data; // Return the original data if decryption fails
  //   }
  // };

  const decryptDataIfNeeded = (data) => {
    try {
      if (typeof data === "string" && data.startsWith("U2FsdGVkX1")) {
        return decrypt(data); // Call your decrypt function
      }
      return data; // Return as-is if not encrypted
    } catch (error) {
      console.error("Error decrypting data:", error);
      return data;
    }
  };

  useEffect(() => {
    const checkLicenseDetails = () => {
      const licenseRef = ref(
        db,
        `superadmin/admins/${adminName1}/License Details`
      );
      onValue(licenseRef, (snapshot) => {
        if (snapshot.exists()) {
          const licenseData = snapshot.val();
          const { LicenseKey, ExpiryDate } = licenseData;

          // Get the current date
          const currentDate = new Date();
          const day = currentDate.getDate();
          const month = currentDate.getMonth() + 1;
          const year = currentDate.getFullYear();
          const issueDate = new Date(year, month - 1, day); // Months are zero-based

          if (LicenseKey) {
            if (ExpiryDate) {
              const [expiryDay, expiryMonth, expiryYear] =
                ExpiryDate.split("-");
              const expiryDate = new Date(
                expiryYear,
                expiryMonth - 1,
                expiryDay
              ); // Months are zero-based

              if (expiryDate >= issueDate) {
                setHasValidLicense(true);
              } else {
                setShowPopup(true);
                setPopupMessage("Your License Has Expired");
                setPopupDescription(
                  "You are not allowed to view the patient details. Renew your license key first to access the data."
                );
                setHasValidLicense(false);
              }
            } else {
              setShowPopup(true);
              setPopupMessage("License Key Required");
              setPopupDescription(
                "You are not allowed to view the patient details. Get the license key first to access the data."
              );
              setHasValidLicense(false);
            }
          } else {
            setShowPopup(true);
            setPopupMessage("License Key Required");
            setPopupDescription(
              "You are not allowed to view the patient details. Get the license key first to access the data."
            );
            setHasValidLicense(false);
          }
        } else {
          setShowPopup(true);
          setPopupMessage("License Key Required");
          setPopupDescription(
            "You are not allowed to view the patient details. Get the license key first to access the data."
          );
          setHasValidLicense(false);
        }
      });
    };

    const timerId = setTimeout(checkLicenseDetails, 500);
    return () => clearTimeout(timerId);
  }, [adminName1]);

  const closeModal = () => {
    setShowPopup(false);
  };

  // Helper function to get prescription data from both legacy and Version 03 structures
  const getPrescriptionData = (patient) => {
    let prescriptionURL = null;
    let prescription = null;


    // For Version 03 patients, check uploads structure
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads)
        .filter((key) => key.toLowerCase().includes("scan"))
        .sort((a, b) => {
          const numA = parseInt(a.replace(/\D/g, "")) || 0;
          const numB = parseInt(b.replace(/\D/g, "")) || 0;
          return numB - numA; // Sort descending to get latest scan
        });


      // Check each scan for prescription data (starting with latest)
      for (const scanKey of scanKeys) {
        const scan = patient.uploads[scanKey];

        if (scan && (scan.PrescriptionURL || scan.Prescription)) {
          // Handle arrays (new format) or single values (legacy format)
          if (
            Array.isArray(scan.PrescriptionURL) &&
            scan.PrescriptionURL.length > 0
          ) {
            const rawURL =
              scan.PrescriptionURL[scan.PrescriptionURL.length - 1];
            prescriptionURL = decryptDataIfNeeded(rawURL);
          } else if (scan.PrescriptionURL) {
            prescriptionURL = decryptDataIfNeeded(scan.PrescriptionURL);
          }

          if (
            Array.isArray(scan.Prescription) &&
            scan.Prescription.length > 0
          ) {
            const rawPrescription =
              scan.Prescription[scan.Prescription.length - 1];
            prescription = decryptDataIfNeeded(rawPrescription);
          } else if (scan.Prescription) {
            prescription = decryptDataIfNeeded(scan.Prescription);
          }

          // If we found prescription data, use it
          if (prescriptionURL || prescription) {
            break;
          }
        }
      }
    }

    // Fallback to legacy fields if no prescription found in uploads
    if (!prescriptionURL && !prescription) {
      prescriptionURL = patient.PrescriptionURL
        ? decryptDataIfNeeded(patient.PrescriptionURL)
        : null;
      prescription = patient.Prescription
        ? decryptDataIfNeeded(patient.Prescription)
        : null;
    }


    return { prescriptionURL, prescription };
  };

  // Helper function to get total prescription count from both legacy and Version 03 structures
  const getPrescriptionCount = (patient) => {
    let totalCount = 0;

    // For Version 03 patients, count all prescriptions in all scans
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads).filter((key) =>
        key.toLowerCase().includes("scan")
      );

      for (const scanKey of scanKeys) {
        const scan = patient.uploads[scanKey];
        if (scan && scan.Prescription) {
          if (Array.isArray(scan.Prescription)) {
            // Count only non-empty decrypted prescriptions
            const validPrescriptions = scan.Prescription.filter(
              (prescription) => {
                const decrypted = decryptDataIfNeeded(prescription);
                return decrypted && decrypted.trim() !== "";
              }
            );
            totalCount += validPrescriptions.length;
          } else if (scan.Prescription) {
            // Check if single prescription is valid after decryption
            const decrypted = decryptDataIfNeeded(scan.Prescription);
            if (decrypted && decrypted.trim() !== "") {
              totalCount += 1;
            }
          }
        }
      }
    } else {
      // For legacy patients, count root level prescriptions
      if (patient.Prescription) {
        if (Array.isArray(patient.Prescription)) {
          // Count only non-empty decrypted prescriptions
          const validPrescriptions = patient.Prescription.filter(
            (prescription) => {
              const decrypted = decryptDataIfNeeded(prescription);
              return decrypted && decrypted.trim() !== "";
            }
          );
          totalCount = validPrescriptions.length;
        } else {
          // Check if single prescription is valid after decryption
          const decrypted = decryptDataIfNeeded(patient.Prescription);
          if (decrypted && decrypted.trim() !== "") {
            totalCount = 1;
          }
        }
      }
    }

    return totalCount;
  };

  // Helper function to get the most recent StudyDate from uploads
  const getLatestStudyDateFromUploads = (uploads) => {
    if (!uploads) return null; // Return null if no uploads

    // Iterate through uploads to find the most recent StudyDate
    const latestStudyDate = Object.keys(uploads).reduce((latestDate, key) => {
      const scan = uploads[key];
      if (scan.StudyDate) {
        const scanDate = new Date(
          scan.StudyDate.split("/").reverse().join("-")
        );
        return scanDate > latestDate ? scanDate : latestDate; // Keep the latest date
      }
      return latestDate;
    }, new Date(0));

    return latestStudyDate > new Date(0) ? latestStudyDate : null; // Return null if no valid dates
  };


  // Helper function to get AI classification from patient data
  const getAIClassification = (patient) => {
    try {
      // Check if modality is XRAY-related first
      const modality = (getLatestModality(patient) || "").toLowerCase();
      const isXrayModality =
        modality.includes("xr") ||
        modality.includes("x ray") ||
        modality.includes("x-ray") ||
        modality.includes("xray");

      // Only process XRAY modality, others show "-"
      if (!isXrayModality) {
        return "-";
      }

      // Check if AI has been run (AI_result flag exists and is true)
      const aiHasRun = patient.AI_result === true;

      // If AI hasn't been run, show "-"
      if (!aiHasRun) {
        return "-";
      }

      // AI has been run, now check for AI_Report
      // Check if patient has Version 03 with uploads structure
      if (patient.Version === "03" && patient.uploads) {
        // Find the latest scan
        const scanKeys = Object.keys(patient.uploads)
          .filter((key) => key.toLowerCase().includes("scan"))
          .map((key) => ({
            key,
            number: parseInt(key.replace(/\D/g, "")) || 0,
          }))
          .sort((a, b) => b.number - a.number);

        if (scanKeys.length > 0) {
          const latestScanKey = scanKeys[0].key;
          const latestScan = patient.uploads[latestScanKey];

          // Check if AI_Report exists in the latest scan
          if (
            latestScan &&
            latestScan.AI_Report &&
            latestScan.AI_Report.classification
          ) {
            return latestScan.AI_Report.classification;
          }
        }
      } else {
        // For legacy patients, check AI_Report at patient level
        if (patient.AI_Report && patient.AI_Report.classification) {
          return patient.AI_Report.classification;
        }
      }

      // AI has run but no AI_Report found
      return "NA";
    } catch (error) {
      console.error("Error getting AI classification:", error);
      return "NA";
    }
  };

  // Helper function to process and filter patient data for doctor
  const processPatientForDoctor = (id, val) => {
    if (!val) return null;

    const { prescriptionURL, prescription } = getPrescriptionData(val);

    const processedPatient = {
      id,
      ...val,
      FullName: decryptDataIfNeeded(val.FullName),
      Age: decryptDataIfNeeded(val.Age),
      Gender: decryptDataIfNeeded(val.Gender),
      ID: decryptDataIfNeeded(val.ID),
      Modality: decryptDataIfNeeded(val.Modality),
      StudyDate: decryptDataIfNeeded(val.StudyDate),
      Timestamp: decryptDataIfNeeded(val.Timestamp),
      Type_of_Dicom_Data: decryptDataIfNeeded(val.Type_of_Dicom_Data),
      Type_of_CT: decryptDataIfNeeded(val.Type_of_CT),
      Dicom_ReportURL: decryptDataIfNeeded(val.Dicom_ReportURL),
      FolderPath: decryptDataIfNeeded(val.FolderPath),
      Dicom_3DURL: decryptDataIfNeeded(val.Dicom_3DURL),
      Dicom_3D: decryptDataIfNeeded(val.Dicom_3D),
      PrescriptionURL: prescriptionURL,
      Prescription: prescription,
      DoctorAssigned: val.DoctorAssigned || [],
      DoctorAssigned_Final: val.DoctorAssigned_Final || [],
      isPriority: val.isPriority || false,
    };

    // Filter based on doctor assignment
    const userRole = localStorage.getItem("role");
    const isHOD = userRole === "hod";

    const doctorAssignedOld = Array.isArray(processedPatient.DoctorAssigned)
      ? processedPatient.DoctorAssigned
      : [];
    const doctorAssignedNew = Array.isArray(processedPatient.DoctorAssigned)
      ? processedPatient.DoctorAssigned.map((entry) =>
          typeof entry === "string" ? entry : entry.name
        )
      : [];
    const doctorAssignedFinal = Array.isArray(processedPatient.DoctorAssigned_Final)
      ? processedPatient.DoctorAssigned_Final.map((entry) => entry.name)
      : [];

    const isDoctorAssignedOld = doctorAssignedOld.includes(docName);
    const isDoctorAssignedNew = doctorAssignedNew.includes(docName);
    const isDoctorAssignedFinal = doctorAssignedFinal.includes(docName);

    let isHODAssigned = false;
    if (isHOD) {
      const isHODAssignedOld = doctorAssignedOld.includes("HOD");
      const isHODAssignedNew = doctorAssignedNew.includes("HOD");
      const isHODAssignedFinal = doctorAssignedFinal.includes("HOD");
      isHODAssigned = isHODAssignedOld || isHODAssignedNew || isHODAssignedFinal;
    }

    // Return patient only if assigned to this doctor
    if (isDoctorAssignedOld || isDoctorAssignedNew || isDoctorAssignedFinal || isHODAssigned) {
      return processedPatient;
    }
    return null;
  };

  // Fetch patient keys using Firebase orderByChild query
  const fetchPatientKeys = async () => {
    if (!adminName1) return;
    
    try {
      
      // Create a query to get latest 100 patients sorted by Timestamp
      const patientsRef = ref(db, `superadmin/admins/${adminName1}/patients`);
      const latestQuery = query(
        patientsRef,
        orderByChild('Timestamp'),
        limitToLast(100)
      );
      
      const snapshot = await get(latestQuery);
      const latestPatients = snapshot.val();
      
      if (!latestPatients) {
        setTotalPatientCount(0);
        setAllPatientKeys([]);
        setPosts([]);
        setNoPatientsAssigned(true);
        return;
      }
      
      // Convert to array and sort
      const keysWithTimestamp = Object.keys(latestPatients).map(id => ({
        id,
        timestamp: latestPatients[id]?.Timestamp || "1970-01-01T00:00:00"
      }));
      
      keysWithTimestamp.sort((a, b) => {
        const dateA = new Date(a.timestamp);
        const dateB = new Date(b.timestamp);
        return dateB - dateA;
      });
      
      const sortedKeys = keysWithTimestamp.map(item => item.id);
      
      // Track the oldest timestamp for loading more patients
      if (keysWithTimestamp.length > 0) {
        const oldestPatient = keysWithTimestamp[keysWithTimestamp.length - 1];
        setOldestTimestamp(oldestPatient.timestamp);
      }
      
      // Check if we got fewer than 100 patients (means no more to load)
      setHasMorePatients(keysWithTimestamp.length >= 100);
      
      // Process and decrypt patient data before storing (only patients assigned to this doctor)
      const processedPatients = [];
      Object.keys(latestPatients).forEach((patientId) => {
        const processed = processPatientForDoctor(patientId, latestPatients[patientId]);
        if (processed) {
          processedPatients.push(processed);
        }
      });
      
      // Sort by priority first, then by date
      processedPatients.sort((a, b) => {
        // Priority patients first
        if (a.isPriority && !b.isPriority) return -1;
        if (!a.isPriority && b.isPriority) return 1;
        // Then sort by date
        const dateA = getSortingDate(a);
        const dateB = getSortingDate(b);
        return dateB - dateA;
      });
      
      setAllPatientKeys(sortedKeys);
      setTotalPatientCount(sortedKeys.length);
      setPosts(processedPatients);
      setNoPatientsAssigned(processedPatients.length === 0);
      setIsInitialBatchLoaded(true); // Mark initial batch as loaded
      
    } catch (error) {
      console.error("Error fetching patients:", error);
    }
  };

  // Load a specific batch of patients
  const loadPatientBatch = async (batchNumber) => {
    if (!adminName1 || loadedBatches.has(batchNumber) || isLoadingBatch || allPatientKeys.length === 0) {
      return;
    }

    setIsLoadingBatch(true);
    
    try {
      const startIndex = batchNumber * batchSize;
      const endIndex = Math.min(startIndex + batchSize, allPatientKeys.length);
      const batchKeys = allPatientKeys.slice(startIndex, endIndex);

      // Data is already processed and stored in posts, just filter what we need
      const batchPatients = posts.filter(patient => 
        batchKeys.includes(patient.id)
      );

      // Sort by priority first, then by date
      batchPatients.sort((a, b) => {
        // Priority patients first
        if (a.isPriority && !b.isPriority) return -1;
        if (!a.isPriority && b.isPriority) return 1;
        // Then sort by date
        const dateA = getSortingDate(a);
        const dateB = getSortingDate(b);
        return dateB - dateA;
      });

      setPosts((prevPosts) => {
        const combined = [...prevPosts, ...batchPatients];
        // Remove duplicates and re-sort
        const uniqueMap = new Map(combined.map(p => [p.id, p]));
        const uniquePatients = Array.from(uniqueMap.values());
        uniquePatients.sort((a, b) => {
          // Priority patients first
          if (a.isPriority && !b.isPriority) return -1;
          if (!a.isPriority && b.isPriority) return 1;
          // Then sort by date
          const dateA = getSortingDate(a);
          const dateB = getSortingDate(b);
          return dateB - dateA;
        });
        setNoPatientsAssigned(uniquePatients.length === 0);
        return uniquePatients;
      });

      setLoadedBatches((prev) => new Set([...prev, batchNumber]));
    } catch (error) {
      console.error("Error loading patient batch:", error);
    } finally {
      setIsLoadingBatch(false);
    }
  };

  // Load more patients (next 100)
  const loadMorePatients = async () => {
    if (!adminName1 || !hasMorePatients || isLoadingBatch || !oldestTimestamp) return;
    
    try {
      setIsLoadingBatch(true);
      
      // Query for next 100 patients before the oldest timestamp
      const patientsRef = ref(db, `superadmin/admins/${adminName1}/patients`);
      const nextQuery = query(
        patientsRef,
        orderByChild('Timestamp'),
        endBefore(oldestTimestamp),
        limitToLast(100)
      );
      
      const snapshot = await get(nextQuery);
      const morePatients = snapshot.val();
      
      if (!morePatients || Object.keys(morePatients).length === 0) {
        setHasMorePatients(false);
        setIsLoadingBatch(false);
        return;
      }
      
      // Convert to array and sort
      const keysWithTimestamp = Object.keys(morePatients).map(id => ({
        id,
        timestamp: morePatients[id]?.Timestamp || "1970-01-01T00:00:00"
      }));
      
      keysWithTimestamp.sort((a, b) => {
        const dateA = new Date(a.timestamp);
        const dateB = new Date(b.timestamp);
        return dateB - dateA;
      });
      
      const newKeys = keysWithTimestamp.map(item => item.id);
      
      // Update oldest timestamp for next load
      if (keysWithTimestamp.length > 0) {
        const oldestPatient = keysWithTimestamp[keysWithTimestamp.length - 1];
        setOldestTimestamp(oldestPatient.timestamp);
      }
      
      // Check if there are more patients
      setHasMorePatients(keysWithTimestamp.length >= 100);
      
      // Process and decrypt patient data before storing (only patients assigned to this doctor)
      const processedMorePatients = [];
      Object.keys(morePatients).forEach((patientId) => {
        const processed = processPatientForDoctor(patientId, morePatients[patientId]);
        if (processed) {
          processedMorePatients.push(processed);
        }
      });
      
      // Append new patients to existing
      setAllPatientKeys(prev => [...prev, ...newKeys]);
      setTotalPatientCount(prev => prev + newKeys.length);
      setPosts(prev => {
        const combined = [...prev, ...processedMorePatients];
        // Remove duplicates and re-sort
        const uniqueMap = new Map(combined.map(p => [p.id, p]));
        const uniquePatients = Array.from(uniqueMap.values());
        uniquePatients.sort((a, b) => {
          // Priority patients first
          if (a.isPriority && !b.isPriority) return -1;
          if (!a.isPriority && b.isPriority) return 1;
          // Then sort by date
          const dateA = getSortingDate(a);
          const dateB = getSortingDate(b);
          return dateB - dateA;
        });
        setNoPatientsAssigned(uniquePatients.length === 0);
        return uniquePatients;
      });
      
    } catch (error) {
      console.error("Error loading more patients:", error);
    } finally {
      setIsLoadingBatch(false);
    }
  };

  // Fetch patient keys on mount or when doctor/refresh changes
  useEffect(() => {
    if (adminName1 && docName) {
      setPosts([]);
      setLoadedBatches(new Set());
      setAllPatientKeys([]);
      setIsInitialBatchLoaded(false); // Reset initial batch flag
      fetchPatientKeys();
    }
  }, [adminName1, docName, refreshTrigger]);

  /* Global real-time listener for all patient changes */
  useEffect(() => {
    if (!adminName1 || !docName) return;

    const patientsRef = ref(db, `superadmin/admins/${adminName1}/patients`);
    
    // Track if this is the initial mount to prevent duplicate additions
    let isInitialLoad = true;
    const initialLoadTimer = setTimeout(() => {
      isInitialLoad = false;
    }, 2000); // Increased timeout to ensure initial batch load completes

    // Helper function to check if patient is assigned to this doctor
    const isAssignedToDoctor = (patientData) => {
      if (!patientData) return false;
      
      const userRole = localStorage.getItem("role");
      const isHOD = userRole === "hod";
      
      const doctorAssignedOld = Array.isArray(patientData.DoctorAssigned)
        ? patientData.DoctorAssigned
        : [];
      const doctorAssignedNew = doctorAssignedOld.map((entry) =>
        typeof entry === "string" ? entry : entry.name
      );
      const doctorAssignedFinal = Array.isArray(patientData.DoctorAssigned_Final)
        ? patientData.DoctorAssigned_Final.map((entry) => entry.name)
        : [];

      const isDoctorAssignedOld = doctorAssignedOld.includes(docName);
      const isDoctorAssignedNew = doctorAssignedNew.includes(docName);
      const isDoctorAssignedFinal = doctorAssignedFinal.includes(docName);

      let isHODAssigned = false;
      if (isHOD) {
        const isHODAssignedOld = doctorAssignedOld.includes("HOD");
        const isHODAssignedNew = doctorAssignedNew.includes("HOD");
        const isHODAssignedFinal = doctorAssignedFinal.includes("HOD");
        isHODAssigned = isHODAssignedOld || isHODAssignedNew || isHODAssignedFinal;
      }

      return isDoctorAssignedOld || isDoctorAssignedNew || isDoctorAssignedFinal || isHODAssigned;
    };

    // Listen for new patients being added
    const handleChildAdded = onChildAdded(patientsRef, (snapshot) => {
      // Skip initial load to prevent duplicates
      if (isInitialLoad) return;
      
      const patientId = snapshot.key;
      const patientData = snapshot.val();
      
      // Check if patient is assigned to this doctor
      if (!isAssignedToDoctor(patientData)) return;
      
      // Check if we already have this patient
      setPosts(prev => {
        if (prev.find(p => p.id === patientId)) {
          return prev; // Already exists, don't add
        }
        
        // Only add new patients if initial batch is loaded and we're beyond the batch limit or user has navigated beyond initial batch
        if (!isInitialBatchLoaded) {
          return prev; // Don't add during initial batch loading
        }
        
        const currentPage = Math.ceil(prev.length / patientsPerPage);
        const shouldAddNewPatient = currentPage >= 5 || prev.length < 100; // Allow if beyond page 5 or under batch limit
        
        if (!shouldAddNewPatient) {
          return prev; // Don't add if we're still within the initial batch pages
        }
        
        // Process and add new patient
        const processed = processPatientForDoctor(patientId, patientData);
        if (processed) {
          // Add to the list
          const updated = [processed, ...prev];
          
          // Update patient keys and count
          setAllPatientKeys(prevKeys => {
            if (!prevKeys.includes(patientId)) {
              return [patientId, ...prevKeys];
            }
            return prevKeys;
          });
          setTotalPatientCount(prevCount => {
            const currentCount = updated.length;
            return currentCount;
          });
          
          // Re-sort to ensure priority patients are at top
          updated.sort((a, b) => {
            // Priority patients first
            if (a.isPriority && !b.isPriority) return -1;
            if (!a.isPriority && b.isPriority) return 1;
            // Then sort by date
            const dateA = getSortingDate(a);
            const dateB = getSortingDate(b);
            return dateB - dateA;
          });
          
          return updated;
        }
        return prev;
      });
    });

    // Listen for patient data changes
    const handleChildChanged = onChildChanged(patientsRef, (snapshot) => {
      const patientId = snapshot.key;
      const patientData = snapshot.val();
      
      // Check if patient is still assigned to this doctor
      const isAssigned = isAssignedToDoctor(patientData);
      
      setPosts(prev => {
        const existingIndex = prev.findIndex(p => p.id === patientId);
        
        if (isAssigned) {
          // Update existing patient data
          const processed = processPatientForDoctor(patientId, patientData);
          if (processed) {
            let updatedList;
            if (existingIndex !== -1) {
              // Update existing patient
              updatedList = [...prev];
              updatedList[existingIndex] = processed;
            } else {
              // Patient was reassigned to this doctor, add to list only if within batch limits
              if (!isInitialBatchLoaded) {
                return prev; // Don't add during initial batch loading
              }
              
              const currentPage = Math.ceil(prev.length / patientsPerPage);
              const shouldAddReassignedPatient = currentPage >= 5 || prev.length < 100;
              
              if (shouldAddReassignedPatient) {
                setAllPatientKeys(prevKeys => {
                  if (!prevKeys.includes(patientId)) {
                    return [patientId, ...prevKeys];
                  }
                  return prevKeys;
                });
                setTotalPatientCount(prevCount => prevCount + 1);
                updatedList = [processed, ...prev];
              } else {
                return prev; // Don't add if within initial batch limit
              }
            }
            
            // Re-sort to ensure priority patients are at top
            updatedList.sort((a, b) => {
              // Priority patients first
              if (a.isPriority && !b.isPriority) return -1;
              if (!a.isPriority && b.isPriority) return 1;
              // Then sort by date
              const dateA = getSortingDate(a);
              const dateB = getSortingDate(b);
              return dateB - dateA;
            });
            
            return updatedList;
          }
        } else {
          // Patient is no longer assigned to this doctor, remove it
          if (existingIndex !== -1) {
            setAllPatientKeys(prevKeys => prevKeys.filter(key => key !== patientId));
            setTotalPatientCount(prevCount => Math.max(0, prevCount - 1));
            return prev.filter(p => p.id !== patientId);
          }
        }
        
        return prev;
      });
    });

    // Listen for patient deletions
    const handleChildRemoved = onChildRemoved(patientsRef, (snapshot) => {
      const patientId = snapshot.key;
      
      setPosts(prev => {
        const exists = prev.find(p => p.id === patientId);
        if (exists) {
          setAllPatientKeys(prevKeys => prevKeys.filter(key => key !== patientId));
          setTotalPatientCount(prevCount => Math.max(0, prevCount - 1));
          return prev.filter(p => p.id !== patientId);
        }
        return prev;
      });
    });

    // Cleanup function
    return () => {
      clearTimeout(initialLoadTimer);
      off(patientsRef, 'child_added', handleChildAdded);
      off(patientsRef, 'child_changed', handleChildChanged);
      off(patientsRef, 'child_removed', handleChildRemoved);
    };
  }, [adminName1, docName, isInitialBatchLoaded, patientsPerPage]);

  // Load initial batch after keys are fetched
  useEffect(() => {
    if (adminName1 && allPatientKeys.length > 0 && loadedBatches.size === 0) {
      loadPatientBatch(0);
    }
  }, [adminName1, allPatientKeys]);

  // Load additional batches based on current page
  useEffect(() => {
    if (!adminName1 || allPatientKeys.length === 0) return;

    const requiredBatch = Math.floor(((currentPage - 1) * patientsPerPage) / batchSize);
    
    if (!loadedBatches.has(requiredBatch)) {
      loadPatientBatch(requiredBatch);
    }

    const nextBatch = requiredBatch + 1;
    const maxBatch = Math.ceil(allPatientKeys.length / batchSize) - 1;
    if (nextBatch <= maxBatch && !loadedBatches.has(nextBatch)) {
      setTimeout(() => loadPatientBatch(nextBatch), 500);
    }
  }, [currentPage, adminName1, loadedBatches, allPatientKeys]);
  // MOBILE DROPDOWN BUTTON

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchDoctorRole = () => {
      // First try specific HOD path
      const hodRef = ref(
        db,
        `superadmin/admins/${adminName1}/doctors/HOD-${docName}`
      );
      onValue(hodRef, (snapshot) => {
        if (snapshot.exists()) {
          const doctorData = snapshot.val();
          setRole(doctorData.Role);
          // Get doctor ID from doctorData or use a fallback
          const docId =
            getDoctorData(doctorData, "ID") || doctorData.ID || docName;
          setDoctorId(docId);
        } else {
          // Try Doctor path
          const doctorRef = ref(
            db,
            `superadmin/admins/${adminName1}/doctors/Doctor-${docName}`
          );
          onValue(doctorRef, (snapshot) => {
            if (snapshot.exists()) {
              const doctorData = snapshot.val();
              setRole(doctorData.Role);
              // Get doctor ID from doctorData or use a fallback
              const docId =
                getDoctorData(doctorData, "ID") || doctorData.ID || docName;
              setDoctorId(docId);
            } else {
              // Try Radiologist path
              const radiologistRef = ref(
                db,
                `superadmin/admins/${adminName1}/doctors/Radiologist-${docName}`
              );
              onValue(radiologistRef, (snapshot) => {
                if (snapshot.exists()) {
                  const doctorData = snapshot.val();
                  setRole(doctorData.Role);
                  // Get doctor ID from doctorData or use a fallback
                  const docId =
                    getDoctorData(doctorData, "ID") || doctorData.ID || docName;
                  setDoctorId(docId);
                } else {
                  // Fallback: search all doctors
                  const doctorsRef = ref(
                    db,
                    `superadmin/admins/${adminName1}/doctors`
                  );
                  onValue(doctorsRef, (snapshot) => {
                    if (snapshot.exists()) {
                      const doctorsData = snapshot.val();
                      let foundRole = null;

                      let foundId = null;
                      Object.entries(doctorsData).forEach(
                        ([key, doctorData]) => {
                          // Get decrypted doctor name and role
                          const decryptedName =
                            getDoctorData(doctorData, "Name") ||
                            doctorData.Name;
                          const decryptedRole =
                            getDoctorData(doctorData, "Role") ||
                            doctorData.Role;

                          if (decryptedName === docName) {
                            foundRole = decryptedRole;
                            foundId =
                              getDoctorData(doctorData, "ID") ||
                              doctorData.ID ||
                              docName;
                          }
                        }
                      );

                      if (foundRole) {
                        setRole(foundRole);
                        setDoctorId(foundId || docName);
                      } else {
                        setRole("Doctor");
                        setDoctorId(docName); // Fallback to docName
                      }
                    } else {
                      console.log("No doctors data found.");
                      setRole("Doctor");
                      setDoctorId(docName); // Fallback to docName
                    }
                  });
                }
              });
            }
          });
        }
      });
    };

    if (adminName1 && docName) {
      fetchDoctorRole();
    }
  }, [adminName1, docName]);


  // dicom folder

  const handleScan = async (
    FolderPath,
    Version,
    uploads,
    patientName,
    patientId,
    Age
  ) => {
    let pathToUse;

    // Check if 'uploads' exists and iterate through them for Version "03"
    if (Version === "03" && uploads) {
      const uploadKeys = Object.keys(uploads || {})
        .map((key) => ({
          key,
          number: parseInt(key.replace("Scan ", ""), 10),
        }))
        .sort((a, b) => b.number - a.number); // Sort uploads by scan number in descending order

      // Find the first valid FolderPath in the uploads
      for (const { key } of uploadKeys) {
        const upload = uploads[key];
        if (
          upload.FolderPath &&
          upload.FolderPath.trim() !== "" &&
          upload.FolderPath !== "Not Uploaded" &&
          upload.FolderPath !== "NA"
        ) {
          pathToUse = upload.FolderPath;
          break; // Stop after finding the first valid FolderPath
        }
      }
    }

    // Fallback to the main FolderPath if no valid path is found in uploads
    if (!pathToUse && FolderPath) {
      pathToUse = FolderPath;
    }

    // If no valid path is found, show an error toast
    if (!pathToUse) {
      toast.info("No scan data available.", {
        position: "top-center",
      });
      return;
    }

    // Decrypt the path
    const decryptedPath = decryptDataIfNeeded(pathToUse);

    if (!decryptedPath) {
      toast.info("Scan data not available or failed to decrypt.", {
        position: "top-center",
      });
      console.error("Decryption failed for FolderPath:", pathToUse);
      return;
    }

    console.log("Decrypted Path:", decryptedPath);

    // Decrypt the patient ID (since patient.ID is encrypted)
    const decryptedPatientId = decryptDataIfNeeded(patientId);

    // Decrypt the doctor ID (since it might be encrypted)
    const decryptedDoctorId = decryptDataIfNeeded(doctorId || docName);

    console.log("DocPanel - handleScan parameters:", {
      patientId: patientId,
      decryptedPatientId: decryptedPatientId,
      Age,
      patientName,
      adminName1,
      docName,
      doctorId: doctorId,
      decryptedDoctorId: decryptedDoctorId,
      role,
    });

    // Construct the model URL
    const modelUrl = `https://tryon.easiofy.com/DWV/?Patient=${encodeURIComponent(
      decryptedPath
    )}&InstituteName=${adminName1}&DoctorName=${docName}&PatientName=${encodeURIComponent(
      patientName
    )}&View=${role}&PatientId=${decryptedPatientId}&age=${Age}&DoctorId=${decryptedDoctorId}`;

    console.log("DocPanel - DICOM Viewer URL:", modelUrl);
    window.open(modelUrl, "_blank");
    // deepa auditlogs: Log doctor 3D view event
    await logDoctor3DView({
      doctorName: docName || "UnknownDoctor",
      patientId: decryptedPatientId, // Use decrypted patient ID for audit logs
      patientName: patientName,
      modelUrl: modelUrl,
    });
  };

  const hasDicomFolder = (patient) => {
    let folderPath;
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads)
        .filter((key) => key.startsWith("Scan"))
        .map((key) => ({
          key,
          number: parseInt(key.replace("Scan ", ""), 10),
        }))
        .sort((a, b) => b.number - a.number); // Sort descending
      for (const { key } of scanKeys) {
        const scan = patient.uploads[key];
        if (scan && scan.FolderPath && scan.FolderPath !== "NA") {
          folderPath = decryptDataIfNeeded(scan.FolderPath);
          break;
        }
      }
    } else if (patient.FolderPath && patient.FolderPath !== "NA") {
      folderPath = decryptDataIfNeeded(patient.FolderPath);
    }
    return Boolean(folderPath);
  };

  // report
  const handleReport = async (patient, action = "view") => {
    let urlToUse;

    // Check if 'uploads' exists and iterate through them to find the latest Dicom_ReportURL
    if (patient.Version === "03" && patient.uploads) {
      const uploadKeys = Object.keys(patient.uploads || {})
        .map((key) => ({
          key,
          number: parseInt(key.replace("Scan ", ""), 10),
        }))
        .sort((a, b) => b.number - a.number); // Sort uploads by scan number in descending order

      // Find the first valid Dicom_ReportURL in the uploads
      for (const { key } of uploadKeys) {
        const upload = patient.uploads[key];
        if (
          upload.Dicom_ReportURL &&
          upload.Dicom_ReportURL.trim() !== "" &&
          upload.Dicom_ReportURL !== "Not Uploaded" &&
          upload.Dicom_ReportURL !== "NA"
        ) {
          urlToUse = upload.Dicom_ReportURL;
          break; // Stop after finding the first valid URL
        }
      }
    }

    // Fallback to the main Dicom_ReportURL if no valid URL is found in uploads
    if (!urlToUse && patient.Dicom_ReportURL) {
      urlToUse = patient.Dicom_ReportURL;
    }

    // If no valid URL is found, show an error toast
    if (!urlToUse) {
      toast.info("No reports available.", {
        position: "top-center",
      });
      return;
    }

    // Decrypt the URL
    const decryptedURL = decryptDataIfNeeded(urlToUse);

    if (!decryptedURL) {
      toast.info("Report not available or failed to decrypt.", {
        position: "top-center",
      });
      console.error("Decryption failed for URL:", urlToUse);
      // deepa auditlogs: Log failure event for report view
      await logDoctorViewReport({
        doctorName: docName || "UnknownDoctor",
        patientId: patient.id,
        patientName: patient.FullName,
        reportUrl: urlToUse || "",
        success: false,
        failure_reason: "Report not available or failed to decrypt.",
      });
      // deepa auditlogs: Log failure event for report download
      await logDoctorDownloadReport({
        doctorName: docName || "UnknownDoctor",
        patientId: patient.id,
        patientName: patient.FullName,
        reportUrl: urlToUse || "",
        success: false,
        failure_reason: "Report not available or failed to decrypt.",
      });
      return;
    }

    console.log("Decrypted URL:", decryptedURL);

    // Handle viewing or downloading the report
    if (action === "view") {
      try {
        // Open the decrypted URL for viewing
        window.open(decryptedURL, "_blank");
        // deepa auditlogs: Log success event for report view
        await logDoctorViewReport({
          doctorName: docName || "UnknownDoctor",
          patientId: patient.id,
          patientName: patient.FullName,
          reportUrl: decryptedURL,
          success: true,
        });
      } catch (error) {
        // deepa auditlogs: Log failure event for report view
        await logDoctorViewReport({
          doctorName: docName || "UnknownDoctor",
          patientId: patient.id,
          patientName: patient.FullName,
          reportUrl: decryptedURL,
          success: false,
          failure_reason: error.message || "Unknown error",
        });
        console.error("Failed to view report:", error);
      }
    } else if (action === "download") {
      try {
        // Fetch and download the report
        const response = await fetch(decryptedURL);
        if (!response.ok) {
          throw new Error("Failed to fetch the file.");
        }
        const blob = await response.blob();
        const link = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = `${patient.FullName || "Patient"}_Report.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        // deepa auditlogs: Log success event for report download
        await logDoctorDownloadReport({
          doctorName: docName || "UnknownDoctor",
          patientId: patient.id,
          patientName: patient.FullName,
          reportUrl: decryptedURL,
          success: true,
        });
      } catch (error) {
        // deepa auditlogs: Log failure event for report download
        await logDoctorDownloadReport({
          doctorName: docName || "UnknownDoctor",
          patientId: patient.id,
          patientName: patient.FullName,
          reportUrl: decryptedURL,
          success: false,
          failure_reason: error.message || "Unknown error",
        });
        console.error("Download failed:", error);
        toast.error("Failed to download the report. Please try again.", {
          position: "top-center",
        });
      }
    } else {
      console.error("Invalid action provided to handleReport:", action);
    }
  };

  const handleDropdownChange = (event, patient) => {
    const selectedOption = event.target.value;

    switch (selectedOption) {
      case "report":
        if (hasValidLicense) {
          let urlToUse;

          // Determine the appropriate URL based on the format
          if (
            Array.isArray(patient.Dicom_ReportURLs) &&
            patient.Dicom_ReportURLs.length > 0
          ) {
            // Use the latest report in the array for newer versions
            urlToUse =
              patient.Version === "03"
                ? patient.Dicom_ReportURLs[patient.Dicom_ReportURLs.length - 1]
                : patient.Dicom_ReportURLs[0];
          } else if (typeof patient.Dicom_ReportURL === "string") {
            // Fallback to single string URL for older versions
            urlToUse = patient.Dicom_ReportURL;
          } else {
            // If no valid URL is found
            toast.info("No report available.", {
              position: "top-center",
            });
            return;
          }

          // Decrypt the URL if needed
          const decryptedURL = decrypt(urlToUse);
          if (decryptedURL) {
            window.open(decryptedURL, "_blank");
          } else {
            toast.info("Report not available or failed to decrypt.", {
              position: "top-center",
            });
          }
        }
        break;

      case "3d":
        if (hasValidLicense && patient.Dicom_3DURL) {
          const view3Durl = `/DoctorPanel/ModelViewer?url=${encodeURIComponent(
            patient.Dicom_3DURL
          )}`;
          window.location.href = view3Durl;
        }
        break;

      case "prescription":
        if (hasValidLicense) {
          // Use the helper function to get prescription data (handles both legacy and Version 03)
          const { prescriptionURL, prescription } =
            getPrescriptionData(patient);

          if (prescriptionURL) {
            try {
              // The prescriptionURL is already decrypted by getPrescriptionData helper function
              console.log(
                "Opening prescription URL from action:",
                prescriptionURL
              );

              if (prescriptionURL && prescriptionURL.trim() !== "") {
                window.open(prescriptionURL, "_blank");
              } else {
                toast.info("Invalid prescription URL", {
                  position: "top-center",
                });
              }
            } catch (error) {
              console.error("Error opening prescription URL:", error);
              toast.info(
                "Failed to open prescription. Please try again later.",
                {
                  position: "top-center",
                }
              );
            }
          } else {
            // No prescription available, open upload modal
            setShowPrescriptionModal(true);
            setSelectedPatient(patient);
            setDirectUpload(true);
          }
        }
        break;

      default:
        break;
    }
  };

  const handleDropdownBlur = (event) => {
    event.target.value = "";
  };

  // ============================
  // AI Architecture Helpers
  // ============================

  function getMonthYearLabel() {
    const date = new Date();
    const monthNames = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${month} ${year}`;
  }

  const handleClearTask = (index) => {
    setAiTasks((prev) => prev.filter((_, i) => i !== index));
  };

  const updateAiTask = (patientId, updates) => {
    setAiTasks((prev) => {
      const existingIndex = prev.findIndex((t) => t.patientId === patientId);
      if (existingIndex >= 0) {
        const newArr = [...prev];
        newArr[existingIndex] = { ...newArr[existingIndex], ...updates };
        return newArr;
      } else {
        return [...prev, { patientId, ...updates }];
      }
    });
  };

  // Common function to store postpaid AI usage
  const storePostpaidAIUsage = async (
    modelName,
    costValue,
    runBy,
    patientName,
    patientID,
    status = "Done"
  ) => {
    // Only exclude Prepaid costing type, log for all others (Cost Per Upload, Cost Per View, Cost Per Upload + View)
    if (costingType && costingType.toLowerCase() === "prepaid") {
      return;
    }
    try {
      const now = new Date();
      const months = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];
      const currentMonth = months[now.getMonth()];
      const currentYear = now.getFullYear();
      const currentMonthYear = `${currentMonth} ${currentYear}`;
      const timestamp = now.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
      const postpaidPath = `superadmin/admins/${adminName1}/Postpaid/${currentMonthYear}`;
      const postpaidRef = ref(db, postpaidPath);
      const snapshot = await get(postpaidRef);
      const nextIndex = snapshot.exists()
        ? Object.keys(snapshot.val()).length
        : 0;
      const usageDetails = {
        AIModelName: modelName,
        Price: String(costValue),
        RunBy: runBy,
        PatientName: encrypt(patientName),
        PatientID: encrypt(patientID),
        Timestamp: timestamp,
        Status: status,
      };
      const usageRef = ref(db, `${postpaidPath}/${nextIndex}`);
      await set(usageRef, usageDetails);
      console.log(
        `Postpaid AI usage stored: ${modelName} by ${runBy} for patient ${patientName} (${patientID})`
      );
    } catch (error) {
      console.error("Error storing postpaid AI usage:", error);
    }
  };

  // If we do a Prepaid flow, we might deduct from wallet
  const handleWalletDeduction = async (costKey, patient, triggeredByUser) => {
    // DEBUG LOGGING START
    console.log("[DocPanel] handleWalletDeduction called:", {
      costKey,
      patient,
      triggeredByUser,
      costingType,
      walletBalance,
      cxrTbCost,
      cxrMulticlassCost,
      xrayFractureCost,
      threeDAbdomenCost,
      tumorAbdomenCost,
      contourAbdomenCost,
      boneFractureCost,
      contouringModelCost,
      tbModelCost,
      liverSegmentationCost,
      contourHaNModelCost,
    });
    // DEBUG LOGGING END
    if (!costKey) return; // No cost? No deduction
    let costValue = 0;
    if (costKey === "CXR-TB") {
      costValue = tbModelCost;
    } else if (costKey === "CXR-TB2") {
      costValue = cxrTb2Cost;
    } else if (costKey === "CXR-Multiclass") {
      costValue = cxrMulticlassCost;
    } else if (costKey === "XRay-Fracture") {
      costValue = boneFractureCost;
    } else if (costKey === "3D-Abdomen") {
      costValue = threeDAbdomenCost;
    } else if (costKey === "Tumor-Abdomen") {
      costValue = tumorAbdomenCost;
    } else if (costKey === "Contour-Abdomen") {
      costValue = contouringModelCost;
    } else if (costKey === "Liver-Segmentation") {
      costValue = liverSegmentationCost;
    } else if (costKey === "Contour-HaN") {
      costValue = contourHaNModelCost;
    } else {
      costValue = 0; // fallback
    }
    // DEBUG LOGGING: costValue
    console.log(
      "[DocPanel] handleWalletDeduction resolved costValue:",
      costValue
    );
    // ... existing code ...

    // Check cost
    if (costingType.toLowerCase() === "prepaid") {
      if (walletBalance < costValue) {
        throw new Error("Insufficient funds");
      }
    }

    // If we get here, we either have enough funds (prepaid) or we are postpaid
    // Deduct if it's Prepaid
    if (costingType.toLowerCase() === "prepaid" && costValue > 0) {
      const walletRef = ref(
        db,
        `superadmin/admins/${adminName1}/Wallet/Wallet_Balance`
      );
      const { snapshot } = await runTransaction(walletRef, (currentBalance) => {
        if (currentBalance === null) return 0;
        return currentBalance - costValue;
      });
      const updatedBalance = snapshot.val() || 0;
      setWalletBalance(updatedBalance);

      // Store transaction
      const currentMonthYear = getMonthYearLabel();
      const walletTxPath = `superadmin/admins/${adminName1}/Wallet/Wallet_Transactions/${currentMonthYear}`;
      const txSnapshot = await get(ref(db, walletTxPath));
      const nextIndex = txSnapshot.exists()
        ? Object.keys(txSnapshot.val()).length
        : 0;

      const transaction = {
        ModelRunby: docName,
        PatientName: patient.FullName || "Unknown",
        PatientID: patient.ID || "Unknown",
        AIModel: costKey, // e.g. "boneFractureCost" or "contouringModelCost"
        AmountDeducted: costValue,
        UpdatedBalance: updatedBalance,
        Timestamp: new Date().toLocaleString("en-GB"),
      };
      await set(ref(db, `${walletTxPath}/${nextIndex}`), transaction);
    }
  };

  // If we want to store "AI_result" or set FolderPath, do it here:
  const markAIResult = async (patientId, newFolderPath = null) => {
    // 1) Mark /AI_result = true
    const aiResultRef = ref(
      db,
      `superadmin/admins/${adminName1}/patients/${patientId}/AI_result`
    );
    await set(aiResultRef, true);

    // 2) Optionally update the FolderPath if "newFolderPath" is provided
    if (newFolderPath) {
      const encryptedFolderPath = encrypt(newFolderPath);
      const folderPathRef = ref(
        db,
        `superadmin/admins/${adminName1}/patients/${patientId}/FolderPath`
      );
      await set(folderPathRef, encryptedFolderPath);
    }
  };

  // A function that, given the model ID (and sub-model), executes the pipeline
  async function executeAIModel({
    patientId,
    modelId,
    subModelId = null,
    modelDisplayName,
  }) {
    const patient = posts.find((p) => p.id === patientId);
    if (!patient) {
      toast.error("Patient data not found", { position: "top-center" });
      return;
    }
    if (patient.AI_result) {
      updateAiTask(patientId, { status: "Already done" });
      toast.info(`AI already run for this patient`, { position: "top-center" });
      return;
    }

    let costValue = 0;
    if (modelId === "XRAY_FRACTURE") {
      costValue = boneFractureCost;
    } else if (modelId === "CONTOUR_ABDOMEN") {
      costValue = contouringModelCost;
    } else if (modelId === "CXR_TB") {
      costValue = tbModelCost;
    } else if (modelId === "CXR_TB2") {
      costValue = cxrTb2Cost;
    } else if (modelId === "3D_ABDOMEN") {
      costValue = threeDAbdomenCost;
    } else if (modelId === "TUMOR_ABDOMEN") {
      costValue = tumorAbdomenCost;
    } else if (modelId === "CXR_MULTICLASS") {
      costValue = cxrMulticlassCost;
    } else if (modelId === "LIVER_SEGMENTATION") {
      costValue = liverSegmentationCost;
    } else if (modelId === "Contour-HaN") {
      costValue = contourHaNModelCost;
    }

    // Add prepaid validation logic (similar to AssignDoctor)
    if (
      costingType &&
      costingType.toLowerCase() === "prepaid" &&
      costValue > 0 &&
      walletBalance < costValue
    ) {
      // Show insufficient balance modal or toast
      toast.error(
        `Not enough balance to run ${
          modelDisplayName || modelId
        }. Required: ${costValue}, Available: ${walletBalance}`,
        {
          position: "top-center",
        }
      );
      updateAiTask(patientId, { status: "Insufficient funds" });
      return;
    }

    // Create AIModelHandler instance
    const aiHandler = new AIModelHandler({
      modelId,
      subModelId,
      adminName: adminName1,
      updateTask: (pid, obj) => updateAiTask(pid, obj),
      markAIResult: async (pid, folderPath) => {
        await markAIResult(pid, folderPath);
      },
      getDecryptedFolderPath: (pat) => {
        let folderPath = "";
        if (pat.Version === "03" && pat.uploads) {
          const scanKeys = Object.keys(pat.uploads)
            .filter((key) => key.toLowerCase().startsWith("scan"))
            .map((key) => ({
              key,
              number: parseInt(key.replace("Scan", "").trim(), 10),
            }))
            .sort((a, b) => b.number - a.number);

          for (const { key } of scanKeys) {
            const scanData = pat.uploads[key];
            if (
              scanData &&
              scanData.FolderPath &&
              scanData.FolderPath !== "NA"
            ) {
              folderPath = decryptDataIfNeeded(scanData.FolderPath);
              break;
            }
          }
        } else {
          folderPath = decryptDataIfNeeded(pat.FolderPath);
        }
        return folderPath;
      },
      toast,
      costingType,
      handleWalletDeduction,
      triggeredByUser: docName,
    });

    try {
      updateAiTask(patientId, {
        status: "Starting",
        model: modelId,
        subModel: subModelId,
      });
      setAiProcessingModalOpen(true);
      await aiHandler.runModel(patientId, patient, {
        costValue,
        walletBalance,
        costingType,
      });

      // Log usage for all costing types except Prepaid
      if (costingType && costingType.toLowerCase() !== "prepaid") {
        await storePostpaidAIUsage(
          modelDisplayName || modelId,
          costValue,
          docName,
          patient.FullName || "Unknown",
          patient.ID || "Unknown",
          "Done"
        );
      }
    } catch (err) {
      console.error(`${modelDisplayName} model error:`, err);
      if (costingType && costingType.toLowerCase() !== "prepaid") {
        await storePostpaidAIUsage(
          modelDisplayName || modelId,
          0,
          docName,
          patient.FullName || "Unknown",
          patient.ID || "Unknown",
          "Fail"
        );
      }
      if (err.message && err.message.includes("Insufficient funds")) {
        updateAiTask(patientId, { status: "Insufficient funds" });
        toast.error(
          `Not enough balance to run ${modelDisplayName || modelId}`,
          {
            position: "top-center",
          }
        );
      } else {
        updateAiTask(patientId, { status: "Failed" });
        toast.error(`${modelDisplayName} model failed`, {
          position: "top-center",
        });
      }
    }
  }

  const handleAI = (patientId) => {
    setAiModalPatientId(patientId);
    setAiModalVisible(true);
  };

  const confirmBoneFracture = (patientId) => {
    const patient = posts.find((p) => p.id === patientId);
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run XRay-Fracture on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "XRAY_FRACTURE",
        modelDisplayName: "XRay-Fracture",
      });
    }
  };

  const confirmContouringAbdomen = (patientId) => {
    const patient = posts.find((p) => p.id === patientId);
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run Contour-Abdomen on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "CONTOUR_ABDOMEN",
        modelDisplayName: "Contour-Abdomen",
      });
    }
  };

  const confirmAbdomenTumorAnalysis = (patientId) => {
    const patient = posts.find((p) => p.id === patientId);
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run Tumor-Abdomen on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "TUMOR_ABDOMEN",
        modelDisplayName: "Tumor-Abdomen",
      });
    }
  };

  const confirmTBDetection = (patientId) => {
    const patient = posts.find((p) => p.id === patientId);
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run CXR-TB on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "CXR_TB",
        modelDisplayName: "CXR-TB",
      });
    }
  };

  const confirmTB2Detection = (patientId) => {
    const patient = posts.find((p) => p.id === patientId);
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run CXR-TB2 Detection on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "CXR_TB2",
        modelDisplayName: "CXR-TB2",
      });
    }
  };

  // ── New "CXR-Multiclass" stub ──
  const confirmCxrMulticlass = (patientId) => {
    const patient = posts.find((p) => p.id === patientId);
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run CXR-Multiclass on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "CXR_MULTICLASS",
        modelDisplayName: "CXR-Multiclass",
      });
    }
  };

  const confirm3DAbdomen = (patientId) => {
    const patient = posts.find((p) => p.id === patientId);
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to generate 3D-Abdomen for ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "THREED_ABDOMEN",
        modelDisplayName: "3D-Abdomen",
      });
    }
  };

  const confirmLiverSegmentation = (patientId) => {
    const patient = posts.find((p) => p.id === patientId);
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run Liver-Segmentation on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "LIVER_SEGMENTATION",
        modelDisplayName: "Liver-Segmentation",
      });
    }
  };

  const confirmContourHaN = (patientId) => {
    const patient = posts.find((p) => p.id === patientId);
    const patientName = patient.FullName || "Patient";
    const confirmMsg = `Do you want to run Contour-HaN generation on ${patientName}?`;
    if (window.confirm(confirmMsg)) {
      setAiModalVisible(false);
      setAiProcessingModalOpen(true);
      executeAIModel({
        patientId,
        modelId: "Contour-HaN",
        modelDisplayName: "Contour-HaN",
      });
    }
  };

  const getEnabledModels = (patient) => {
    const mod = (getLatestModality(patient) || "").toLowerCase();
    const results = {
      xrayFracture: false,
      cxrTb: false,
      cxrMulticlass: false,
      contourAbdomen: false,
      tumorAbdomen: false,
      threeDAbdomen: false,
      liverSegmentation: false,
      contourHaN: false, // Add this line
    };

    // X-ray–based models
    if (
      mod.includes("xray") ||
      mod.includes("x-ray") ||
      mod.includes("xr") ||
      mod.includes("x ray")
    ) {
      results.xrayFracture = aiModelsEnabled["XRay-Fracture"] === true;
      results.cxrTb = aiModelsEnabled["CXR-TB"] === true;
      results.cxrTb2 = aiModelsEnabled["CXR-TB2"] === true;
      results.cxrMulticlass = aiModelsEnabled["CXR-Multiclass"] === true;
    }

    // CT–based models
    if (mod.includes("ct")) {
      results.contourAbdomen = aiModelsEnabled["Contour-Abdomen"] === true;
      results.tumorAbdomen = aiModelsEnabled["Tumor-Abdomen"] === true;
      results.threeDAbdomen = aiModelsEnabled["3D-Abdomen"] === true;
      results.liverSegmentation =
        aiModelsEnabled["Liver-Segmentation"] === true;
      results.contourHaN = aiModelsEnabled["Contour-HaN"] === true;
    }

    return results;
  };

  const getLatestModality = (patient) => {
    if (!patient) return "N/A";

    let modalityValue = "N/A";
    if (patient.Version === "03" && patient.uploads) {
      const scanKeys = Object.keys(patient.uploads)
        .filter((key) => key.toLowerCase().startsWith("scan"))
        .map((key) => ({
          key,
          number: parseInt(key.replace("Scan", "").trim(), 10),
        }))
        .sort((a, b) => b.number - a.number);

      for (const { key } of scanKeys) {
        const scan = patient.uploads[key];
        if (
          scan.Modality &&
          typeof scan.Modality === "string" &&
          scan.Modality.trim() !== ""
        ) {
          modalityValue = scan.Modality.trim();
          break;
        }
      }
    }
    if (modalityValue === "N/A" && patient.Modality) {
      if (Array.isArray(patient.Modality)) {
        modalityValue =
          patient.Modality.length > 0 ? patient.Modality[0] : "N/A";
      } else if (typeof patient.Modality === "string") {
        modalityValue = patient.Modality;
      }
    }
    return modalityValue;
  };

  const showAIButton = (patient) => {
    const mod = (getLatestModality(patient) || "").toLowerCase();
    if (mod.includes("ct")) return true;
    if (mod.includes("xr") || mod.includes("x ray") || mod.includes("x-ray")) {
      return true;
    }
    if (mod.includes("mri") || mod.includes("mr")) return true;
    return false;
  };

  // Pagination handlers
  const handlePageChange = async (event, value) => {
    const currentTotalPages = hasMorePatients 
      ? Math.ceil(filteredPatients.length / patientsPerPage)
      : Math.ceil(filteredPatients.length / patientsPerPage);
    
    // If user is trying to go beyond current loaded pages and more patients exist
    if (value > currentTotalPages && hasMorePatients && !isLoadingBatch) {
      await loadMorePatients();
      // After loading, set to the first page of newly loaded data
      setCurrentPage(currentTotalPages + 1);
    } else {
      setCurrentPage(value);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const handleGeneratedPatientDataClick = (patientId) => {
    // Encrypt the admin name and patient ID for security
    const encryptedAdminName = window.btoa(adminName1);
    const encryptedPatientId = window.btoa(patientId);

    // Navigate to the GeneratedPatientData component
    window.open(
      `/patient/${encryptedAdminName}/${encryptedPatientId}`,
      "_blank"
    );
  };

  const patientHasMedicalData = (patient) => {
    if (!patient) return false;

    // Check if patient has any medical records in Firebase
    const hasUploads =
      patient.uploads && Object.keys(patient.uploads).length > 0;
    const hasReports =
      patient.Dicom_ReportURL && patient.Dicom_ReportURL !== "Not Uploaded";
    const hasPrescriptions = getPrescriptionCount(patient) > 0;

    return hasUploads || hasReports || hasPrescriptions;
  };

  const handleResetAI = async (patientId) => {
    if (
      !window.confirm(
        "Are you sure you want to reset AI results for this patient?"
      )
    )
      return;

    // locate the folderPath exactly as you do for handleScan / executeAIModel
    const patient = posts[patientId] || posts.find((p) => p.id === patientId);
    let folderPath;
    if (patient.Version === "03" && patient.uploads) {
      // pick the latest upload with a FolderPath
      const scans = Object.values(patient.uploads)
        .filter((s) => s.FolderPath && s.FolderPath !== "NA")
        .reverse();
      folderPath = scans.length
        ? decryptDataIfNeeded(scans[0].FolderPath)
        : null;
    } else {
      folderPath = decryptDataIfNeeded(patient.FolderPath);
    }
    if (!folderPath) {
      toast.error("No storage folder found", { position: "top-center" });
      return;
    }

    const storage = getStorage();
    const mod = (getLatestModality(patient) || "").toLowerCase();

    try {
      if (mod.includes("ct")) {
        // ── Contouring ── delete all dicom-seg-[1–9].dcm anywhere under folderPath
        const walk = async (refPath) => {
          const { prefixes, items } = await listAll(refPath);
          // delete matching files in this folder
          await Promise.all(
            items
              .filter((i) => /^dicom\-seg\-[1-9]\.dcm$/.test(i.name))
              .map((i) => deleteObject(i))
          );
          // and recurse
          await Promise.all(prefixes.map((p) => walk(p)));
        };
        await walk(storageRef(storage, folderPath));

        // Also remove 3D GLB files for CT scans
        const folderRef = storageRef(storage, folderPath);
        const { items } = await listAll(folderRef);
        const threeDFiles = items.filter((fileRef) =>
          fileRef.name.toLowerCase().endsWith(".glb")
        );
        if (threeDFiles.length > 0) {
          await Promise.all(
            threeDFiles.map((fileRef) => deleteObject(fileRef))
          );
          console.log(
            `Deleted ${threeDFiles.length} 3D GLB files from CT folder`
          );
        }

        // Also check patient root directory for GLB files (where 3D-Abdomen saves them)
        const patientRootPath = `superadmin/admins/${adminName1}/patients/${patientId}`;
        const patientRootRef = storageRef(storage, patientRootPath);
        try {
          const { items: rootItems } = await listAll(patientRootRef);
          const rootThreeDFiles = rootItems.filter((fileRef) =>
            fileRef.name.toLowerCase().endsWith(".glb")
          );
          if (rootThreeDFiles.length > 0) {
            await Promise.all(
              rootThreeDFiles.map((fileRef) => deleteObject(fileRef))
            );
            console.log(
              `Deleted ${rootThreeDFiles.length} 3D GLB files from patient root directory`
            );
          }
        } catch (error) {
          console.log(
            "No GLB files found in patient root directory or error accessing it:",
            error.message
          );
        }

        // Clear 3D file references in Realtime DB for CT scans
        const patientDbRef = ref(
          db,
          `superadmin/admins/${adminName1}/patients/${patientId}`
        );
        const patientSnapshot = await get(patientDbRef);
        const patientData = patientSnapshot.val();

        if (
          patientData &&
          patientData.Version === "03" &&
          patientData.uploads
        ) {
          // For Version 03 patients with uploads structure
          const uploads = patientData.uploads;
          const scanKeys = Object.keys(uploads).filter((key) =>
            key.toLowerCase().startsWith("scan")
          );

          // Clear 3D data from all scans
          for (const scanKey of scanKeys) {
            const scanPath3DRef = ref(
              db,
              `superadmin/admins/${adminName1}/patients/${patientId}/uploads/${scanKey}/Path3D`
            );
            const scanDicom3DURLRef = ref(
              db,
              `superadmin/admins/${adminName1}/patients/${patientId}/uploads/${scanKey}/Dicom_3DURL`
            );

            await Promise.all([
              set(scanPath3DRef, ""),
              set(scanDicom3DURLRef, ""),
            ]);
          }
        } else {
          // For legacy patients, clear patient level 3D data
          const path3DRef = ref(
            db,
            `superadmin/admins/${adminName1}/patients/${patientId}/Path3D`
          );
          const dicom3DURLRef = ref(
            db,
            `superadmin/admins/${adminName1}/patients/${patientId}/Dicom_3DURL`
          );

          await Promise.all([set(path3DRef, ""), set(dicom3DURLRef, "")]);
        }

        toast.success("AI results have been reset", {
          position: "top-center",
        });
      } else {
        // ── Bone / TB ── delete everything inside `AI_Results` subfolder
        const aiResultsRef = storageRef(storage, `${folderPath}/AI_Results`);
        const { prefixes, items } = await listAll(aiResultsRef);
        await Promise.all(items.map((i) => deleteObject(i)));
        for (const p of prefixes) {
          const nested = await listAll(p);
          await Promise.all(nested.items.map((i) => deleteObject(i)));
        }

        toast.success("AI results have been reset", { position: "top-center" });
      }

      // Clean up AI_Report data from Firebase Realtime Database using AIModelHandler
      await AIModelHandler.resetAIReport(patientId, adminName1);

      // flip the flag in Realtime DB
      const aiResultRef = ref(
        db,
        `superadmin/admins/${adminName1}/patients/${patientId}/AI_result`
      );
      await set(aiResultRef, false);
    } catch (err) {
      console.error("Reset AI error:", err);
      toast.error("Failed to reset AI results", { position: "top-center" });
    }
  };

  return (
    <>
      {/* New Warning Message at Top Center (shown only if any AI task is still running) */}
      {aiTasks.length > 0 &&
        aiTasks.some(
          (task) =>
            ![
              "done",
              "already done",
              "failed",
              "server down",
              "insufficient funds",
              "unknown id",
            ].includes(task.status.toLowerCase())
        ) && (
          <div
            style={{
              position: "fixed",
              top: "70px",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "#fff3f3",
              padding: "12px 24px",
              border: "2px solid #ff4d4d",
              borderRadius: "8px",
              zIndex: 10000,
              fontWeight: "bold",
              fontSize: "16px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              textAlign: "center",
            }}
          >
            AI Processing in Progress – Do not close or refresh this page.
          </div>
        )}

      {/* Main container for the component */}
      <div className="container-fluid">
        <div className="top-panel">
          {/* Logout Button */}
          <Dropdown className="ml-auto">
            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
              {docName}
            </Dropdown.Toggle>
            <Dropdown.Menu className="logout-menu">
              <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {/* Page Headings - deepa fix ui: reduced margin to remove blank space */}
        <h1
          className="text-center doctorPanelHeading"
          style={{ marginBottom: "20px", fontSize: "28px", fontWeight: "bold" }}
        ></h1>

        {/* Main Container */}
        <div className="containerDocPanel">
          {/* Flash message for license - deepa fix ui: shorter message with close button */}
          {!hasValidLicense && showFlashMessage && (
            <div className="flash-message">
              <button
                className="flash-close-btn"
                onClick={() => setShowFlashMessage(false)}
                aria-label="Close"
              >
                ×
              </button>
              <p className="flash-text">License Required - Please Renew</p>
            </div>
          )}

          {/* Search Bar */}
          <div className="search-bar-containerAssignDoc">
            <div>
              <input
                type="text"
                placeholder="🔍 Patient ID"
                value={searchTerms.patientId}
                onChange={(e) =>
                  setSearchTerms((prev) => ({
                    ...prev,
                    patientId: e.target.value,
                  }))
                }
                onFocus={(e) => (e.target.placeholder = "")} // Viniith Fix this 05-08-2025 - Hide placeholder on focus
                onBlur={(e) => (e.target.placeholder = "🔍 Patient ID")} // Viniith Fix this 05-08-2025 - Show placeholder on blur
                className="search-input"
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="🔍 Name"
                value={searchTerms.fullName}
                onChange={(e) =>
                  setSearchTerms((prev) => ({
                    ...prev,
                    fullName: e.target.value,
                  }))
                }
                onFocus={(e) => (e.target.placeholder = "")} // Viniith Fix this 05-08-2025 - Hide placeholder on focus
                onBlur={(e) => (e.target.placeholder = "🔍 Name")} // Viniith Fix this 05-08-2025 - Show placeholder on blur
                className="search-input"
              />
            </div>

            <div className="table-search-bar">
              <select
                name="modality"
                value={searchTerms.modality}
                onChange={(e) =>
                  setSearchTerms((prev) => ({
                    ...prev,
                    modality: e.target.value,
                  }))
                }
                className="search-select"
              >
                <option value="">🔍 Modality</option>
                <option value="na">NA</option>
                {[
                  ...new Set(
                    posts
                      .map((patient) => {
                        let latestModality = "";

                        try {
                          // Extract modality from uploads for Version 03
                          if (patient?.uploads && patient.Version === "03") {
                            const scanKeys = Object.keys(patient.uploads)
                              .filter((key) => key.startsWith("Scan"))
                              .map((key) => ({
                                key,
                                number: parseInt(key.replace("Scan ", ""), 10),
                              }))
                              .sort((a, b) => b.number - a.number);

                            for (const { key } of scanKeys) {
                              const scan = patient.uploads[key];
                              if (
                                scan.Modality &&
                                typeof scan.Modality === "string" &&
                                scan.Modality.trim() !== "" &&
                                scan.Modality.trim().toLowerCase() !== "na" // Exclude invalid "NA"
                              ) {
                                latestModality = scan.Modality.trim();
                                break;
                              }
                            }
                          }

                          // Fallback to patient.Modality
                          if (!latestModality) {
                            latestModality =
                              typeof patient.Modality === "string" &&
                              patient.Modality.trim() !== ""
                                ? patient.Modality.trim()
                                : "N/A";
                          }

                          return latestModality.toLowerCase(); // Normalize to lowercase for consistency
                        } catch (error) {
                          console.error(
                            "Error processing patient modality:",
                            error
                          );
                          return "n/a"; // Default to "n/a" on error
                        }
                      })
                      .filter((modality) => modality && modality !== "n/a") // Remove empty or invalid values
                  ),
                ]
                  .filter((modality) => modality === "xray") // Filter only XRAY
                  .sort()
                  .map((modality, index) => (
                    <option key={index} value={modality}>
                      {modality.toUpperCase()} {/* Display as uppercase */}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          {/* Table */}
          <div>
            {/* Loading indicator for Firebase search */}
            {isSearchingFirebase && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px', padding: '10px', backgroundColor: '#f0f8ff', borderRadius: '5px' }}>
                <CircularProgress size={20} style={{ color: '#1976d2' }} />
                <span style={{ fontSize: '14px', color: '#666', fontWeight: '500' }}>Searching Patients...</span>
              </div>
            )}

            <div className="scrollable-table">
              <table className="style-table ASSIGNDOCADMINPANELTABLE">
                <thead>
                  <tr>
                    <th></th>
                    <th className="th-head T-NO" style={{ width: "80px" }}>
                      ID
                    </th>
                    <th className="th-head T-NAME" style={{ width: "100px" }}>
                      Name
                    </th>
                    <th>Age</th>
                    <th className="th-head T-NO">Study</th>
                    <th className="th-head" style={{ width: "100px" }}>
                      Modality
                    </th>
                    <th>Study Date</th>
                    <th className="th-head">
                      {(() => {
                        const userRole = localStorage.getItem("role");
                        return userRole === "hod" ? "Referred By" : "Centre Name";
                      })()}
                    </th>
                    <th className="T-NO">Received</th>
                    <th className="th-head T-NO" style={{ width: "80px" }}>
                      Assign Date
                    </th>
                    <th className="th-head T-NO" style={{ width: "100px" }}>
                      Report Date
                    </th>
                    {(() => {
                      const userRole = localStorage.getItem("role");
                      const isHOD = userRole === "hod";
                      return isHOD ? (
                        <th className="th-head T-NO" style={{ width: "100px" }}>
                          Reported By
                        </th>
                      ) : null;
                    })()}
                    <th className="th-head">Status</th>
                    {/* <th className="th-head T-NO" style={{ width: "120px" }}>
                      AI Result
                    </th> */}
                    <th className="th-head T-NO" style={{ width: "200px" }}>
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {!isInitialBatchLoaded && currentPatients.length === 0 ? (
                    <tr>
                      <td colSpan={(() => {
                        const userRole = localStorage.getItem("role");
                        const isHOD = userRole === "hod";
                        return isHOD ? "14" : "13";
                      })()} style={{ textAlign: "center", padding: "20px" }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                          <CircularProgress size={24} style={{ color: '#1976d2' }} />
                          <span style={{ fontSize: '14px', color: '#666', fontWeight: '500' }}>Loading patients...</span>
                        </div>
                      </td>
                    </tr>
                  ) : currentPatients && currentPatients.length > 0 ? (
                    currentPatients.map((patient) => {
                      const canShowAI = showAIButton(patient);
                      const { bone, contouring, tb } =
                        getEnabledModels(patient);

                      // Only show priority highlighting if report is not finalized
                      const showPriorityHighlight = patient.isPriority && patient.Report_Status !== "Final";
                      const priorityBgColor = showPriorityHighlight ? '#b6d0dd' : '';
                      const tdStyle = showPriorityHighlight ? { backgroundColor: '#b6d0dd' } : {};
                      
                      return (
                        <tr 
                          key={patient.id}
                          style={{
                            backgroundColor: showPriorityHighlight ? '#b6d0dd' : 'transparent',
                            borderLeft: showPriorityHighlight ? '5px solid #ffc107' : 'none',
                            fontWeight: showPriorityHighlight ? '500' : 'normal'
                          }}
                        >
                          {/* History Icon */}
                          <td className="T-NO" style={{ width: "50px", ...tdStyle }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {(() => {
                                const userRole = localStorage.getItem("role");
                                const isHOD = userRole === "hod";
                                const isRadiologist = role === "Radiologist";
                                const canAccessClinicalHistory =
                                  isHOD || isRadiologist;
                                const hasHistory =
                                  patient.Clinical_Textarea ||
                                  patient.Clinical_Filepath;
                                if (hasHistory) {
                                  // Show HistoryIcon when clinical history exists
                                  const tooltipTitle = isHOD
                                    ? "View Clinical History"
                                    : "View Clinical History";
                                  return (
                                    <Tooltip title={tooltipTitle} arrow>
                                      <HistoryIcon
                                        className="clinical-history-icon"
                                        onClick={() =>
                                          handleClinicalHistoryClick(
                                            patient.id,
                                            patient
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "xl-large",
                                        }}
                                      />
                                    </Tooltip>
                                  );
                                } else if (isHOD) {
                                  // Show AddIcon only for HOD when no clinical history exists
                                  return (
                                    <Tooltip title="Add Clinical History" arrow>
                                      <AddIcon
                                        className="clinical-history-icon"
                                        onClick={() =>
                                          handleClinicalHistoryClick(
                                            patient.id,
                                            patient,
                                            true // isAddMode = true
                                          )
                                        }
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "xl-large",
                                        }}
                                      />
                                    </Tooltip>
                                  );
                                } else if (isRadiologist) {
                                  // Show disabled HistoryIcon for Radiologist when no history
                                  return (
                                    <Tooltip title="No Clinical History" arrow>
                                      <HistoryIcon
                                        style={{
                                          cursor: "not-allowed",
                                          fontSize: "xl-large",
                                          opacity: 0.5,
                                        }}
                                      />
                                    </Tooltip>
                                  );
                                } else {
                                  // Show disabled HistoryIcon for regular doctors when no history
                                  return (
                                    <Tooltip title="No Clinical History" arrow>
                                      <HistoryIcon
                                        style={{
                                          cursor: "not-allowed",
                                          fontSize: "xl-large",
                                          opacity: 0.5,
                                        }}
                                      />
                                    </Tooltip>
                                  );
                                }
                              })()}
                            </div>
                          </td>
                          {/* Dicomfolder and id */}
                          {/* Patient ID */}
                          {/* <td className="T-NO" style={{ width: "80px" }}>
<a
  href="#"
  onClick={(e) => {
    e.preventDefault(); // Prevent default anchor behavior
    handleScan(patient.FolderPath, patient.Version, patient.uploads, patient.FullName, patient.ID, patient.Age);
  }}
>
  {decrypt(patient.ID)}
</a>
  </td> */}
                          <td className="T-NO" style={{ width: "80px", ...tdStyle }}>
                            <p className="study-column-wrap">
                            {hasDicomFolder(patient) ? (
                              <a
                                href="#"
                                // deepa auditlogs: Make click handler async for audit logging
                                onClick={async (e) => {
                                  e.preventDefault();
                                  await handleScan(
                                    patient.FolderPath,
                                    patient.Version,
                                    patient.uploads,
                                    patient.FullName,
                                    patient.ID, // Pass patient ID (from ID column)
                                    patient.Age // Pass Age for DICOM viewer
                                  );
                                }}
                              >
                                {decrypt(patient.ID)}
                              </a>
                            ) : (
                              <span style={{ color: "grey" }}>
                                {decrypt(patient.ID)}
                              </span>
                            )}
                            </p>
                          </td>

                          {/* Patient Name */}
                          <td
                            className="admin-name T-NAME"
                            style={{ width: "100px", fontSize: "13px", ...tdStyle }}
                          >
                            <p className="study-column-wrap">
                            <a
                              href="#"
                              // deepa auditlogs: Make click handler async for patient record view logging
                              onClick={async (e) => {
                                e.preventDefault();
                                try {
                                  // deepa auditlogs: Debug log before audit log call
                                  console.log(
                                    "Logging patient record view...",
                                    patient.id,
                                    patient.FullName
                                  );
                                  await logDoctorPatientRecordView({
                                    doctorName: docName || "UnknownDoctor",
                                    patientId: patient.id,
                                    patientName: patient.FullName,
                                    success: true,
                                  });
                                  // deepa auditlogs: Debug log after audit log call
                                  console.log("Log function called");
                                  handleGeneratedPatientDataClick(patient.id);
                                } catch (error) {
                                  // deepa auditlogs: Log failure event
                                  await logDoctorPatientRecordView({
                                    doctorName: docName || "UnknownDoctor",
                                    patientId: patient.id,
                                    patientName: patient.FullName,
                                    success: false,
                                    failure_reason:
                                      error.message || "Unknown error",
                                  });
                                  console.error(
                                    "Failed to view patient record:",
                                    error
                                  );
                                }
                              }}
                            >
                              {patient.FullName.toUpperCase()}
                            </a>
                            </p>
                          </td>

                          {/* Patient Age */}
                          <td className="T-NO" style={{ width: "60px", ...tdStyle }}>
                            {patient.Age || "NA"}
                          </td>

                          {/* Study (Type of DICOM Data or Type of CT) */}

                          <td className="T-NO" style={tdStyle}>
                            <p className="study-column-wrap">
                            {(() => {
                              let typeOfStudy =
                                patient.Type_of_Data ||
                                patient.Type_of_Dicom_Data ||
                                patient.Type_of_CT ||
                                "NA";

                              if (patient.Version === "03" && patient.uploads) {
                                const scanKeys = Object.keys(patient.uploads)
                                  .filter((key) => key.startsWith("Scan"))
                                  .sort((a, b) => {
                                    const numA = parseInt(
                                      a.replace("Scan ", ""),
                                      10
                                    );
                                    const numB = parseInt(
                                      b.replace("Scan ", ""),
                                      10
                                    );
                                    return numB - numA; // Sort descending
                                  });

                                for (const key of scanKeys) {
                                  const scan = patient.uploads[key];
                                  if (
                                    scan.Type_of_Data &&
                                    typeof scan.Type_of_Data === "string" &&
                                    scan.Type_of_Data.trim() !== ""
                                  ) {
                                    typeOfStudy = scan.Type_of_Data.trim();
                                    break;
                                  } else if (
                                    scan.Type_of_Dicom_Data &&
                                    typeof scan.Type_of_Dicom_Data ===
                                      "string" &&
                                    scan.Type_of_Dicom_Data.trim() !== ""
                                  ) {
                                    typeOfStudy =
                                      scan.Type_of_Dicom_Data.trim();
                                    break;
                                  } else if (
                                    scan.Type_of_CT &&
                                    typeof scan.Type_of_CT === "string" &&
                                    scan.Type_of_CT.trim() !== ""
                                  ) {
                                    typeOfStudy = scan.Type_of_CT.trim();
                                    break;
                                  }
                                }
                              }

                              return typeOfStudy;
                            })()}
                            </p>
                          </td>

                          <td className="T-NO" style={tdStyle}>
                            {(() => {
                              let latestModality = patient.Modality || "NA";
                              if (patient.Version === "03" && patient.uploads) {
                                const scanKeys = Object.keys(patient.uploads)
                                  .filter((key) => key.startsWith("Scan"))
                                  .sort((a, b) => {
                                    const numA = parseInt(
                                      a.replace("Scan ", ""),
                                      10
                                    );
                                    const numB = parseInt(
                                      b.replace("Scan ", ""),
                                      10
                                    );
                                    return numB - numA; // Sort descending
                                  });

                                for (const key of scanKeys) {
                                  const scan = patient.uploads[key];
                                  if (
                                    scan.Modality &&
                                    scan.Modality.trim() !== "" &&
                                    scan.Modality.trim() !== "NA"
                                  ) {
                                    latestModality = scan.Modality.trim();
                                    break; // Stop at the first valid modality
                                  }
                                }
                              }
                              return latestModality;
                            })()}

                            {/* Study Date */}
                          </td>
                          <td className="T-NO" style={{ width: "120px", ...tdStyle }}>
                            {(() => {
                              let latestStudyDate = patient.StudyDate || "N/A"; // Default to main StudyDate

                              if (patient.Version === "03" && patient.uploads) {
                                const scanKeys = Object.keys(patient.uploads)
                                  .filter((key) => key.startsWith("Scan"))
                                  .map((key) => ({
                                    key,
                                    number: parseInt(
                                      key.replace("Scan ", ""),
                                      10
                                    ),
                                  }))
                                  .sort((a, b) => b.number - a.number); // Sort by descending scan number

                                // Find the latest valid StudyDate in the uploads
                                for (const { key } of scanKeys) {
                                  const scan = patient.uploads[key];
                                  if (
                                    scan.StudyDate &&
                                    typeof scan.StudyDate === "string" &&
                                    scan.StudyDate.trim() !== ""
                                  ) {
                                    latestStudyDate = scan.StudyDate.trim();
                                    break; // Stop at the first valid StudyDate
                                  }
                                }
                              }

                              return latestStudyDate;
                            })()}
                          </td>
                          {/* Centre Name (Added by) / Referred By (for HOD) */}
                          <td className="T-NO" style={tdStyle}>
                            {(() => {
                              const userRole = localStorage.getItem("role");
                              if (userRole === "hod") {
                                return patient.Refered_By_Doctor || "NA";
                              }
                              return patient.Addedby || "NA";
                            })()}
                          </td>

                          {/* Received (Timestamp) */}
                          {/* <td className="T-NO" style={{ width: "150px" }}>
                            {patient.Timestamp || "N/A"}
                          </td> */}
                          <td className="T-NO" style={{ width: "120px", ...tdStyle }}>
                            {patient.Timestamp
                              ? (() => {
                                  const formattedTimestamp = formatTimestampForDisplay(patient.Timestamp);
                                  const [date, time] = formattedTimestamp.split(", ");
                                  return (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <span>{date}</span>
                                      {time && <span>{time}</span>}
                                    </div>
                                  );
                                })()
                              : "NA"}
                          </td>

                          {/* Assign Date */}
                          <td className="T-NO" style={{ width: "120px", ...tdStyle }}>
                            {(() => {
                              const docAssigned = patient.DoctorAssigned || [];
                              const currentDocName = docName;
                              const currentRole = role;

                              const splitDateTime = (dt) => {
                                if (!dt || typeof dt !== "string")
                                  return { date: dt || "NA", time: "" };
                                if (dt.includes(", ")) {
                                  const [date, time] = dt.split(", ");
                                  return { date, time };
                                }
                                const lastSpace = dt.lastIndexOf(" ");
                                if (lastSpace > 0) {
                                  return {
                                    date: dt.slice(0, lastSpace),
                                    time: dt.slice(lastSpace + 1),
                                  };
                                }
                                return { date: dt, time: "" };
                              };

                              if (docAssigned.length > 0 && currentDocName) {
                                const currentDoctorAssignments = docAssigned
                                  .filter(
                                    (doctor) =>
                                      typeof doctor === "object" &&
                                      (doctor.assignedAt || doctor.timestamp) &&
                                      (doctor.name === currentDocName ||
                                        (doctor.name === currentRole &&
                                          currentRole) ||
                                        (doctor.name === "HOD" &&
                                          currentRole === "HOD") ||
                                        (doctor.name === "Radiologist" &&
                                          currentRole === "Radiologist") ||
                                        (doctor.name === "Doctor" &&
                                          currentRole === "Doctor"))
                                  )
                                  .sort((a, b) => {
                                    const dateA = new Date(
                                      a.assignedAt || a.timestamp
                                    );
                                    const dateB = new Date(
                                      b.assignedAt || b.timestamp
                                    );
                                    return dateB - dateA;
                                  });

                                if (currentDoctorAssignments.length > 0) {
                                  const latestAssignment =
                                    currentDoctorAssignments[0];
                                  const dateTime =
                                    latestAssignment.assignedAt ||
                                    latestAssignment.timestamp;
                                  const { date, time } =
                                    splitDateTime(dateTime);

                                  return (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <span>{date}</span>
                                      {time && <span>{time}</span>}
                                    </div>
                                  );
                                }
                              }

                              return "NA";
                            })()}
                          </td>

                          {/* Report Date */}
                          {/* <td className="T-NO" style={{ width: "100px" }}>
                            {patient.Report_TimeStamp
                              ? patient.Report_TimeStamp
                              : "NA"}
                          </td> */}
                          <td className="T-NO" style={{ width: "100px", ...tdStyle }}>
                            {patient.Report_TimeStamp &&
                            patient.Report_TimeStamp !== "NA"
                              ? (() => {
                                  const [date, time] =
                                    patient.Report_TimeStamp.split(", ");
                                  return (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <span>{date}</span>
                                      {time && <span>{time}</span>}
                                    </div>
                                  );
                                })()
                              : "NA"}
                          </td>

                          {/* Reported By - Only visible for HOD */}
                          {(() => {
                            const userRole = localStorage.getItem("role");
                            const isHOD = userRole === "hod";
                            return isHOD ? (
                              <td className="T-NO" style={{ width: "100px", ...tdStyle }}>
                                {patient.Report_Addedby || "NA"}
                              </td>
                            ) : null;
                          })()}

                          {/* Status */}
                          <td className="T-NO" style={tdStyle}>
                            {patient.Report_Status || "NA"}
                          </td>

                          {/* AI Result */}
                          {/* <td className="T-NO" style={{ width: "120px", ...tdStyle }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px",
                                height: "100%",
                                textAlign: "center",
                              }}
                            >
                              {getAIClassification(patient)}
                            </div>
                          </td> */}

                          {/* Action Buttons */}
                          <td className="T-NO" style={{ width: "200px", ...tdStyle }}>
                            <div
                              id="doctor-tablebuttons"
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <>
                                {/* code added 18feb */}
                                {/* View/Download Report Icon */}
                                <div className="action-icons">
                                  {(() => {
                                    let reportAvailable = false;

                                    // Check if main Dicom_ReportURL is valid using the helper
                                    if (
                                      isValidString(patient.Dicom_ReportURL) &&
                                      patient.Dicom_ReportURL.toLowerCase() !==
                                        "not uploaded" &&
                                      patient.Dicom_ReportURL.toLowerCase() !==
                                        "na"
                                    ) {
                                      reportAvailable = true;
                                    }

                                    // Check if uploads have any valid Dicom_ReportURL
                                    if (
                                      patient.Version === "03" &&
                                      patient.uploads
                                    ) {
                                      const uploadKeys = Object.keys(
                                        patient.uploads
                                      )
                                        .map((key) => ({
                                          key,
                                          number: parseInt(
                                            key.replace("Scan ", ""),
                                            10
                                          ),
                                        }))
                                        .sort((a, b) => b.number - a.number);

                                      for (const { key } of uploadKeys) {
                                        const upload = patient.uploads[key];
                                        if (
                                          isValidString(
                                            upload.Dicom_ReportURL
                                          ) &&
                                          upload.Dicom_ReportURL.toLowerCase() !==
                                            "not uploaded" &&
                                          upload.Dicom_ReportURL.toLowerCase() !==
                                            "na"
                                        ) {
                                          reportAvailable = true;
                                          break;
                                        }
                                      }
                                    }

                                    return reportAvailable ? (
                                      <Tooltip title="View Report" arrow>
                                        <VisibilityIcon
                                          onClick={() =>
                                            handleReport(patient, "view")
                                          }
                                          style={{
                                            cursor: "pointer",
                                            marginRight: "10px",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <Tooltip
                                        title="Report not available"
                                        arrow
                                      >
                                        <VisibilityOffOutlinedIcon
                                          onClick={() => {
                                            toast.info(
                                              "Report not available.",
                                              {
                                                position: "top-center",
                                              }
                                            );
                                          }}
                                          style={{
                                            cursor: "not-allowed",
                                            marginRight: "10px",
                                            color: "gray",
                                          }}
                                        />
                                      </Tooltip>
                                    );
                                  })()}

                                  {(() => {
                                    const urlToUse = (() => {
                                      // For Version "03", check uploads first
                                      if (
                                        patient.Version === "03" &&
                                        patient.uploads
                                      ) {
                                        const uploadKeys = Object.keys(
                                          patient.uploads || {}
                                        )
                                          .map((key) => ({
                                            key,
                                            number: parseInt(
                                              key.replace("Scan ", ""),
                                              10
                                            ),
                                          }))
                                          .sort((a, b) => b.number - a.number);

                                        for (const { key } of uploadKeys) {
                                          const upload = patient.uploads[key];
                                          if (
                                            isValidString(
                                              upload.Dicom_ReportURL
                                            ) &&
                                            upload.Dicom_ReportURL.toLowerCase() !==
                                              "not uploaded" &&
                                            upload.Dicom_ReportURL.toLowerCase() !==
                                              "na"
                                          ) {
                                            return upload.Dicom_ReportURL;
                                          }
                                        }
                                      }

                                      // Then check the main Dicom_ReportURL
                                      if (
                                        isValidString(
                                          patient.Dicom_ReportURL
                                        ) &&
                                        patient.Dicom_ReportURL.toLowerCase() !==
                                          "not uploaded" &&
                                        patient.Dicom_ReportURL.toLowerCase() !==
                                          "na"
                                      ) {
                                        return patient.Dicom_ReportURL;
                                      }

                                      return null;
                                    })();

                                    return urlToUse ? (
                                      <Tooltip title="Download Report" arrow>
                                        <DownloadIcon
                                          onClick={() =>
                                            handleReport(patient, "download")
                                          }
                                          style={{
                                            cursor: "pointer",
                                            marginRight: "10px",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <Tooltip title="File not available" arrow>
                                        <FileDownloadOffOutlinedIcon
                                          onClick={() => {
                                            toast.info("File not available.", {
                                              position: "top-center",
                                            });
                                          }}
                                          style={{
                                            cursor: "not-allowed",
                                            marginRight: "10px",
                                            color: "gray",
                                          }}
                                        />
                                      </Tooltip>
                                    );
                                  })()}
                                </div>
                                <Tooltip
                                  title={
                                    getPrescriptionCount(patient) > 0
                                      ? `Prescriptions (${getPrescriptionCount(
                                          patient
                                        )}) -  View or Add`
                                      : " Prescription"
                                  }
                                  arrow
                                >
                                  <FontAwesomeIcon
                                    icon={faPrescription}
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "10px",
                                      fontSize: "14px", // Adjust size as needed
                                    }}
                                    onClick={() => {
                                      setSelectedPatient(patient);
                                      setShowPrescriptionModal(true);
                                      setDirectUpload(false);
                                    }}
                                  />
                                </Tooltip>

                                <div className="action-icons">
                                  {(() => {
                                    let threeDURL;

                                    // Check if patient has uploads (Version 03)
                                    if (
                                      patient.Version === "03" &&
                                      patient.uploads
                                    ) {
                                      const uploadKeys = Object.keys(
                                        patient.uploads || {}
                                      )
                                        .map((key) => ({
                                          key,
                                          number: parseInt(
                                            key.replace("Scan ", ""),
                                            10
                                          ),
                                        }))
                                        .sort((a, b) => b.number - a.number); // Sort by scan number, descending

                                      // Iterate through uploads from latest to oldest
                                      for (const { key } of uploadKeys) {
                                        const upload = patient.uploads[key];
                                        if (
                                          upload.Dicom_3DURL && // Check if the 3D URL exists
                                          upload.Dicom_3DURL !==
                                            "Not Uploaded" &&
                                          upload.Dicom_3DURL !== "NA"
                                        ) {
                                          threeDURL = upload.Dicom_3DURL;
                                          break; // Stop after finding the first valid 3D URL
                                        }
                                      }
                                    } else {
                                      // Fallback for older data (string-based 3D URL)
                                      if (
                                        patient.Dicom_3DURL &&
                                        patient.Dicom_3DURL !==
                                          "Not Uploaded" &&
                                        patient.Dicom_3DURL !== "NA"
                                      ) {
                                        threeDURL = patient.Dicom_3DURL;
                                      }
                                    }

                                    // 3D View Section - COMMENTED OUT
                                    /* return threeDURL ? (
                                      <>
                                        <Tooltip title="3D View" arrow>
                                          <ThreeDRotationIcon
                                            onClick={async () => {
                                              const decrypted3DURL =
                                                decryptDataIfNeeded(threeDURL);
                                              if (decrypted3DURL) {
                                                try {
                                                  const secretKey =
                                                    process.env
                                                      .REACT_APP_SECRET_KEY;
                                                  const encryptedURL =
                                                    CryptoJS.AES.encrypt(
                                                      decrypted3DURL,
                                                      secretKey
                                                    ).toString();
                                                  const modelViewerURL = ` https://health.easiofy.com/3dViewer/?src=${encodeURIComponent(
                                                    encryptedURL
                                                  )}`;
                                                  window.open(
                                                    modelViewerURL,
                                                    "_blank"
                                                  );
                                                  await logDoctor3DViewAction({
                                                    doctorName:
                                                      docName ||
                                                      "UnknownDoctor",
                                                    patientId: patient.id,
                                                    patientName:
                                                      patient.FullName,
                                                    modelUrl: decrypted3DURL,
                                                    success: true,
                                                  });
                                                } catch (error) {
                                                  await logDoctor3DViewAction({
                                                    doctorName:
                                                      docName ||
                                                      "UnknownDoctor",
                                                    patientId: patient.id,
                                                    patientName:
                                                      patient.FullName,
                                                    modelUrl: decrypted3DURL,
                                                    success: false,
                                                    failure_reason:
                                                      error.message ||
                                                      "Unknown error",
                                                  });
                                                  console.error(
                                                    "Failed to open 3D view:",
                                                    error
                                                  );
                                                }
                                              } else {
                                                toast.info(
                                                  "3D view is not available",
                                                  {
                                                    position: "top-center",
                                                  }
                                                );
                                                await logDoctor3DViewAction({
                                                  doctorName:
                                                    docName || "UnknownDoctor",
                                                  patientId: patient.id,
                                                  patientName: patient.FullName,
                                                  modelUrl: threeDURL || "",
                                                  success: false,
                                                  failure_reason:
                                                    "3D view is not available",
                                                });
                                              }
                                            }}
                                            style={{
                                              cursor: "pointer",
                                              marginRight: "10px",
                                            }}
                                          />
                                        </Tooltip>
                                      </>
                                    ) : (
                                      <>
                                        <Tooltip
                                          title="3D view not available"
                                          arrow
                                        >
                                          <ThreeDRotationIcon
                                            onClick={() => {
                                              toast.info(
                                                "3D view is not available",
                                                {
                                                  position: "top-center",
                                                }
                                              );
                                            }}
                                            style={{
                                              cursor: "not-allowed",
                                              marginRight: "10px",
                                              color: "gray",
                                            }}
                                          />
                                        </Tooltip>
                                      </>
                                    ); */
                                  })()}
                                </div>
                                {/* Upload Data functionality for HOD */}
                                {(() => {
                                  const userRole = localStorage.getItem("role");
                                  const isHOD = userRole === "hod";

                                  if (isHOD) {
                                    return (
                                      <Tooltip title="Upload Data" arrow>
                                        <UploadFileOutlinedIcon
                                          onClick={() =>
                                            handleUploadData(patient.id)
                                          }
                                          style={{
                                            color: "black",
                                            cursor: "pointer",
                                            marginRight: "10px",
                                          }}
                                        />
                                      </Tooltip>
                                    );
                                  }
                                  return null;
                                })()}
                                {(() => {
                                  const shouldShowAI =
                                    role === "Radiologist" ||
                                    (role &&
                                      role.toLowerCase().includes("hod"));
                                  return shouldShowAI;
                                })() &&
                                  (canShowAI ? (
                                    <Tooltip
                                      title={
                                        patient.AI_result
                                          ? "Already generated"
                                          : "Generate AI"
                                      }
                                      arrow
                                    >
                                      <span>
                                        <button
                                          onClick={() => handleAI(patient.id)}
                                          style={{
                                            cursor: "pointer",
                                            marginRight: "10px",
                                          }}
                                          disabled={Boolean(patient.AI_result)}
                                        >
                                          AI
                                        </button>
                                      </span>
                                    </Tooltip>
                                  ) : null)}
                                {/* {(role === "Radiologist" ||
                                  (role &&
                                    role.toLowerCase().includes("hod"))) &&
                                  patient.AI_result && (
                                    <Tooltip title="Reset AI results" arrow>
                                      <RestartAltIcon
                                        onClick={() =>
                                          handleResetAI(patient.id)
                                        }
                                        style={{
                                          cursor: "pointer",
                                          marginLeft: "10px",
                                        }}
                                      />
                                    </Tooltip>
                                  )} */}
                              </>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={(() => {
                        const userRole = localStorage.getItem("role");
                        const isHOD = userRole === "hod";
                        return isHOD ? "14" : "13"; // 14 columns if HOD (includes Reported By), 13 otherwise
                      })()} style={{ textAlign: "center" }}>
                        No patients Available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginTop: "20px",
                gap: "15px",
              }}
            >
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                siblingCount={1}
                boundaryCount={1}
                color="primary"
                showFirstButton
                showLastButton={false}
              />
              
              {isLoadingBatch && (
                <div style={{
                  padding: "10px 20px",
                  fontSize: "14px",
                  color: "#007bff",
                  fontWeight: "600",
                }}>
                  Loading more patients...
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Clinical History Modal */}
        {clinicalHistoryModalVisible && (
          <div
            className="ClinicalHistory-modal-background"
            onClick={() => setClinicalHistoryModalVisible(false)}
          >
            <div
              className="ClinicalHistory-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="ClinicalHistory-modal-header">
                <h2>
                  {isEditing ? "Add Clinical History" : "View Clinical History"}
                </h2>
                <span
                  className="ClinicalHistory-close-btn"
                  onClick={() => setClinicalHistoryModalVisible(false)}
                >
                  &times;
                </span>
              </div>

              <div className="ClinicalHistory-modal-body">
                <div className="form-group">
                  <label htmlFor="clinicalHistoryTextarea">
                    Clinical History:
                  </label>
                  <textarea
                    id="clinicalHistoryTextarea"
                    value={clinicalHistoryText}
                    onChange={(e) => setClinicalHistoryText(e.target.value)}
                    className="form-control"
                    rows="4"
                    readOnly={!isEditing}
                    placeholder={isEditing ? "Enter clinical history..." : ""}
                  />
                </div>

                {isEditing && (
                  <div className="form-group">
                    <label>Attach File:</label>
                    <input
                      type="file"
                      onChange={(e) => setAttachedFile(e.target.files[0])}
                      className="form-control"
                    />
                  </div>
                )}

                {attachedFile && !isEditing && (
                  <div className="form-group">
                    <label>Attached File:</label>
                    <a
                      href={attachedFile.name}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Show File
                    </a>
                  </div>
                )}

                {isEditing && (
                  <div className="form-group" style={{ marginTop: "20px" }}>
                    <button
                      onClick={handleSaveClinicalHistory}
                      className="btn btn-primary"
                      style={{ marginRight: "10px" }}
                    >
                      Save
                    </button>
                    <button
                      onClick={() => {
                        setIsEditing(false);
                        setClinicalHistoryModalVisible(false);
                      }}
                      className="btn btn-secondary"
                    >
                      Cancel
                    </button>
                  </div>
                )}

                {!isEditing && (
                  <div className="form-group" style={{ marginTop: "20px" }}>
                    <button
                      onClick={() => setClinicalHistoryModalVisible(false)}
                      className="btn btn-primary"
                    >
                      Exit
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* License Validation Modal */}
        <Modal isOpen={showPopup} className="custom-modal">
          <h2 className="modal-title">{popupMessage}</h2>
          <p className="modal-description">{popupDescription}</p>
          <button className="modal-button" onClick={closeModal}>
            Close
          </button>
        </Modal>

        {/* Prescription Uploading Modal */}
        {showPrescriptionModal && selectedPatient && (
          <Modal
            isOpen={showPrescriptionModal}
            className="custom-modal-prescription"
          >
            <button
              className="close-button-PresModal"
              onClick={() => {
                setShowPrescriptionModal(false);
                setDirectUpload(false); // Reset the directUpload state
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <br />
            <PatientItem
              key={selectedPatient.id}
              patient={selectedPatient}
              adminName1={adminName1}
              openUploadModalDirectly={directUpload}
              onClose={() => {
                setShowPrescriptionModal(false);
                setDirectUpload(false); // Reset the directUpload state
              }}
              onPrescriptionUpload={handlePrescriptionUpload}
            />
          </Modal>
        )}
        <div>
          <ChatNot />
        </div>
      </div>

      {/* AI Model Modal */}
      {aiModalVisible && aiModalPatientId && (
        <div
          className="ai-modal-overlay"
          onClick={() => {
            setAiModalVisible(false);
          }}
        >
          <div
            className="ai-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ai-modal-header">
              <h2>Select AI Model</h2>
              <button
                className="close-btn"
                onClick={() => {
                  setAiModalVisible(false);
                }}
              >
                &times;
              </button>
            </div>
            <div className="ai-modal-body">
              {(() => {
                const patient = posts.find((p) => p.id === aiModalPatientId);
                const {
                  xrayFracture,
                  cxrTb,
                  cxrMulticlass,
                  contourAbdomen,
                  tumorAbdomen,
                  threeDAbdomen,
                  liverSegmentation,
                  contourHaN,
                  cxrTb2,
                } = getEnabledModels(patient);
                const mod = (getLatestModality(patient) || "").toLowerCase();
                const isXray =
                  mod.includes("xray") ||
                  mod.includes("x-ray") ||
                  mod.includes("xr") ||
                  mod.includes("x ray");
                const isCT = mod.includes("ct");

                return (
                  <ul>
                    {/* X-ray models */}
                    {isXray && (
                      <>
                        {/* CXR-Multiclass (displayed as CXR-TB-3) */}
                        {cxrMulticlass && (
                          <li
                            onClick={() =>
                              cxrMulticlass
                                ? confirmCxrMulticlass(aiModalPatientId)
                                : null
                            }
                            className="ai-model-option"
                            style={{
                              opacity: cxrMulticlass ? 1 : 0.5,
                              cursor: cxrMulticlass ? "pointer" : "not-allowed",
                            }}
                          >
                            CXR-TB-3
                          </li>
                        )}
                      </>
                    )}
                    {/* Other X-ray models - COMMENTED OUT */}
                    {/* {isXray && (
                      <>
                        {/* XRay-Fracture * /}
                        <li
                          onClick={() =>
                            xrayFracture
                              ? confirmBoneFracture(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: xrayFracture ? 1 : 0.5,
                            cursor: xrayFracture ? "pointer" : "not-allowed",
                          }}
                        >
                          XRay-Fracture
                        </li>

                        {/* CXR-TB * /}
                        <li
                          onClick={() =>
                            cxrTb ? confirmTBDetection(aiModalPatientId) : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: cxrTb ? 1 : 0.5,
                            cursor: cxrTb ? "pointer" : "not-allowed",
                          }}
                        >
                          CXR-TB
                        </li>

                        {/* CXR-TB2 * /}
                        <li
                          onClick={() =>
                            cxrTb2
                              ? confirmTB2Detection(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: cxrTb2 ? 1 : 0.5,
                            cursor: cxrTb2 ? "pointer" : "not-allowed",
                          }}
                        >
                          CXR-TB2
                        </li>

                        {/* CXR-Multiclass * /}
                        <li
                          onClick={() =>
                            cxrMulticlass
                              ? confirmCxrMulticlass(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: cxrMulticlass ? 1 : 0.5,
                            cursor: cxrMulticlass ? "pointer" : "not-allowed",
                          }}
                        >
                          CXR-Multiclass
                        </li>
                      </>
                    )} */}

                    {isCT && (
                      <>
                        {/* Contour-Abdomen */}
                        <li
                          onClick={() =>
                            contourAbdomen
                              ? confirmContouringAbdomen(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: contourAbdomen ? 1 : 0.5,
                            cursor: contourAbdomen ? "pointer" : "not-allowed",
                          }}
                        >
                          Contour-Abdomen
                        </li>

                        {/* Tumor-Abdomen - COMMENTED OUT */}
                        {/* <li
                          onClick={() =>
                            tumorAbdomen
                              ? confirmAbdomenTumorAnalysis(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: tumorAbdomen ? 1 : 0.5,
                            cursor: tumorAbdomen ? "pointer" : "not-allowed",
                          }}
                        >
                          Tumor-Abdomen
                        </li> */}

                        {/* 3D-Abdomen - COMMENTED OUT */}
                        {/* <li
                          onClick={() =>
                            threeDAbdomen
                              ? confirm3DAbdomen(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: threeDAbdomen ? 1 : 0.5,
                            cursor: threeDAbdomen ? "pointer" : "not-allowed",
                          }}
                        >
                          3D-Abdomen
                        </li> */}

                        {/* Liver-Segmentation - COMMENTED OUT */}
                        {/* <li
                          onClick={() =>
                            liverSegmentation
                              ? confirmLiverSegmentation(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: liverSegmentation ? 1 : 0.5,
                            cursor: liverSegmentation
                              ? "pointer"
                              : "not-allowed",
                          }}
                        >
                          Liver-Segmentation
                        </li> */}

                        {/* Contour-HaN */}
                        <li
                          onClick={() =>
                            contourHaN
                              ? confirmContourHaN(aiModalPatientId)
                              : null
                          }
                          className="ai-model-option"
                          style={{
                            opacity: contourHaN ? 1 : 0.5,
                            cursor: contourHaN ? "pointer" : "not-allowed",
                          }}
                        >
                          Contour-HaN
                        </li>
                      </>
                    )}
                  </ul>
                );
              })()}
            </div>
            <div className="ai-modal-footer">
              <button
                onClick={() => {
                  setAiModalVisible(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Floating button to open AI tasks (only if we have tasks but the modal is fully closed) */}
      {aiTasks.length > 0 && !aiProcessingModalOpen && (
        <button
          className="open-ai-tasks-btn"
          onClick={() => setAiProcessingModalOpen(true)}
        >
          AI Tasks
        </button>
      )}

      {/* AI Processing Status Modal */}
      {aiTasks.length > 0 && aiProcessingModalOpen && (
        <div
          className="ai-processing-modal-overlay"
          style={{ display: aiProcessingModalMinimized ? "none" : "flex" }}
          onClick={() => {
            // click outside to close? Up to you if you want that.
            // setAiProcessingModalOpen(false);
          }}
        >
          <div
            className="ai-processing-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ai-processing-modal-header">
              <h3>AI Processing Status</h3>
              <div className="ai-processing-header-buttons">
                <button onClick={() => setAiProcessingModalMinimized(true)}>
                  Minimize
                </button>
              </div>
            </div>
            <div className="ai-processing-modal-body">
              {aiTasks.map((task, idx) => (
                <div key={idx} className="ai-task-item">
                  <div>
                    <strong>Patient ID:</strong> {task.patientId}
                  </div>
                  <div>
                    <strong>Model:</strong> {task.model || "N/A"}
                    {task.subModel ? ` (${task.subModel})` : ""}
                  </div>
                  <div>
                    <strong>Status:</strong> {task.status}
                    {task.status &&
                      task.status.toLowerCase().includes("in-progress") && (
                        <CircularProgress
                          size={16}
                          style={{ color: "#000", marginLeft: "5px" }}
                        />
                      )}
                  </div>
                  {(task.status.toLowerCase() === "done" ||
                    task.status.toLowerCase() === "failed" ||
                    task.status.toLowerCase() === "insufficient funds" ||
                    task.status.toLowerCase() === "server down" ||
                    task.status.toLowerCase() === "unknown id") && (
                    <button onClick={() => handleClearTask(idx)}>Clear</button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Minimized Bar for AI Processing (if user hits "Minimize" but not "Close") */}
      {aiTasks.length > 0 &&
        aiProcessingModalOpen &&
        aiProcessingModalMinimized && (
          <div
            className="ai-processing-minimized-bar"
            onClick={() => setAiProcessingModalMinimized(false)}
          >
            <span style={{ fontWeight: "bold" }}>
              AI Tasks (click to expand)
            </span>
          </div>
        )}

      {/* Clinical History Modal */}
      {clinicalHistoryModalVisible && (
        <div className="clinical-history-modal-overlay">
          <div className="clinical-history-modal-content">
            <div className="clinical-history-modal-header">
              <h3>
                {(() => {
                  const userRole = localStorage.getItem("role");
                  const isHOD = userRole === "hod";

                  if (isHOD) {
                    if (isEditing) {
                      return isEditingExistingHistory
                        ? "Edit Clinical History"
                        : "Add Clinical History";
                    } else {
                      return "View Clinical History";
                    }
                  } else {
                    return "View Clinical History";
                  }
                })()}
              </h3>
              <span
                className="ClinicalHistory-close-btn"
                onClick={() => setClinicalHistoryModalVisible(false)}
              >
                &times;
              </span>
            </div>
            <div className="clinical-history-modal-body">
              <div className="clinical-history-section">
                <label>Clinical History:</label>
                {isEditing ? (
                  <textarea
                    value={clinicalHistoryText}
                    onChange={(e) => setClinicalHistoryText(e.target.value)}
                    placeholder="Enter clinical history..."
                    rows={6}
                    className="clinical-history-textarea"
                  />
                ) : (
                  <div className="clinical-history-readonly">
                    {clinicalHistoryText || "No clinical history available"}
                  </div>
                )}
              </div>

              {/* Show attached file in view mode */}
              {(() => {
                const currentPatient = posts.find(
                  (p) => p.id === selectedPatientId
                );
                const hasFilepath = currentPatient?.Clinical_Filepath;
                return !isEditing && hasFilepath ? (
                  <div className="clinical-history-file-section">
                    <label>Attached File:</label>
                    <div className="clinical-history-file">
                      <a
                        href={decryptDataIfNeeded(hasFilepath)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Show File
                      </a>
                    </div>
                  </div>
                ) : null;
              })()}

              {/* Show file upload in edit mode */}
              {isEditing && (
                <div className="clinical-history-file-section">
                  <label>Attach File:</label>
                  <div className="clinical-history-file-upload">
                    <input
                      type="file"
                      id="clinical-file-input"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          setAttachedFile(file);
                        }
                      }}
                    />
                    <button
                      type="button"
                      onClick={() =>
                        document.getElementById("clinical-file-input").click()
                      }
                      className="choose-file-button"
                    >
                      Choose File
                    </button>
                    <span className="file-chosen-text">
                      {attachedFile && attachedFile instanceof File
                        ? attachedFile.name
                        : "No file chosen"}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="clinical-history-modal-footer">
              {(() => {
                const userRole = localStorage.getItem("role");
                const isHOD = userRole === "hod";
                const isRadiologist = role === "Radiologist";

                if (isHOD) {
                  if (isEditing) {
                    // Show Save/Cancel buttons when in edit mode
                    return (
                      <>
                        <button
                          onClick={() => handleSaveClinicalHistory()}
                          className="save-button"
                        >
                          Save
                        </button>
                        <button
                          onClick={handleCancelClinicalHistory}
                          className="cancel-button"
                        >
                          Cancel
                        </button>
                      </>
                    );
                  } else {
                    // Show Edit button for HOD in view mode
                    return (
                      <button
                        onClick={() => {
                          setIsEditing(true);
                          setAttachedFile(null); // Clear attached file when entering edit mode
                        }}
                        className="edit-button"
                      >
                        Edit
                      </button>
                    );
                  }
                } else {
                  // Radiologist and Regular doctors - no buttons needed (can use X to close)
                  return null;
                }
              })()}
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default DoctorPanel;
